/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AbandonedCartWidget from '../components/AbandonedCartWidget';
import ViewCartButton from '../components/AbandonedCartWidget/ViewCartButton';
import Accordion from '../components/Accordion';
import AccordionItem from '../components/Accordion/AccordionItem';
import AnimatedBanner from '../components/AnimatedBanner';
import AnimatedBannerWithImages from '../components/AnimatedBanner/AnimatedBannerWithImages';
import AnimatedBannerWithVideo from '../components/AnimatedBanner/AnimatedBannerWithVideo';
import AppointmentBooked from '../components/AppointmentBooked';
import AutoScrollingBanners from '../components/AutoScrollingBanners';
import Marquee from '../components/AutoScrollingBanners/Marquee';
import BannerWithPopup from '../components/BannerWithPopup';
import PopoverItem from '../components/BannerWithPopup/PopoverItem';
import BannerWithText from '../components/BannerWithText';
import BirthdayRewards from '../components/BirthdayRewards';
import ModalNeedAddProduct from '../components/BirthdayRewards/ModalNeedAddProduct';
import BookExperienceComponent from '../components/BookingExperience/BookExperienceComponent';
import SelectProduct from '../components/BookingExperience/BookExperienceComponent/SelectProduct';
import ScheduleAppointmentComponent from '../components/BookingExperience/ScheduleAppointmentComponent';
import FormikStep from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep';
import ContactDetailsForm from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm';
import ContactDetailSubtitle from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm/ContactDetailSubtitle';
import EmailExistModal from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm/EmailExistModal';
import ErrorHandlerComp from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm/ErrorHandlerComp';
import FormLayout from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm/FormLayout';
import InputForm from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm/InputForm';
import LoginModal from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm/LoginModal';
import OTPInputHandler from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm/OTPInputHandler';
import PolicyAndTermCheckbox from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ContactDetailsForm/PolicyAndTermCheckbox';
import PersonalizeExperienceForm from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/PersonalizeExperienceForm';
import AdditionalSelection from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/PersonalizeExperienceForm/AdditionalSelection';
import SelectScent from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/PersonalizeExperienceForm/SelectScent';
import SelectTea from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/PersonalizeExperienceForm/SelectTea';
import ScheduleAppointmentForm from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ScheduleAppointmentForm';
import SelectDate from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ScheduleAppointmentForm/SelectDate';
import SelectStoreSchedule from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ScheduleAppointmentForm/SelectStoreSchedule';
import searchScheduleFilterStoreBar from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ScheduleAppointmentForm/SelectStoreSchedule/searchScheduleFilterStoreBar';
import filterStoreScheduleBtn from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ScheduleAppointmentForm/SelectStoreSchedule/searchScheduleFilterStoreBar/filterStoreScheduleBtn';
import SelectTimeSlotAndGuest from '../components/BookingExperience/ScheduleAppointmentComponent/FormikStep/ScheduleAppointmentForm/SelectTimeSlotAndGuest';
import ProgressBar from '../components/BookingExperience/ScheduleAppointmentComponent/ProgressBar';
import UpdateAppointmentSuccessPopup from '../components/BookingExperience/ScheduleAppointmentComponent/UpdateAppointmentSuccessPopup';
import BundleBuyingOption from '../components/BundleBuyingOption';
import BundleBuyingOptionLayout from '../components/BundleBuyingOptionLayout';
import BundleBOAddToCartButton from '../components/BundleBuyingOptionLayout/BundleBOAddToCartButton';
import BundleBOAdditionalOptions from '../components/BundleBuyingOptionLayout/BundleBOAdditionalOptions';
import BundleBOAdditionalOptionsList from '../components/BundleBuyingOptionLayout/BundleBOAdditionalOptions/BundleBOAdditionalOptionsList';
import BundleBOFreeGifts from '../components/BundleBuyingOptionLayout/BundleBOFreeGifts';
import BundleBOFreeGiftList from '../components/BundleBuyingOptionLayout/BundleBOFreeGifts/BundleBOFreeGiftList';
import BundleBOHeader from '../components/BundleBuyingOptionLayout/BundleBOHeader';
import BundleBOImages from '../components/BundleBuyingOptionLayout/BundleBOImages';
import BundleBOLabels from '../components/BundleBuyingOptionLayout/BundleBOImages/BundleBOLabels';
import BundleBOPaymentInfo from '../components/BundleBuyingOptionLayout/BundleBOPaymentInfo';
import BundleBOShippingInfo from '../components/BundleBuyingOptionLayout/BundleBOShippingInfo';
import BundleBOVariants from '../components/BundleBuyingOptionLayout/BundleBOVariants';
import BundleBOVariantsList from '../components/BundleBuyingOptionLayout/BundleBOVariants/BundleBOVariantsList';
import BundleBOWarranty from '../components/BundleBuyingOptionLayout/BundleBOWarranty';
import BundleBOWarrantyList from '../components/BundleBuyingOptionLayout/BundleBOWarranty/BundleBOWarrantyList';
import BundleElements from '../components/BundleElements';
import LabelItem from '../components/BundleElements/LabelItem';
import BundleKeyFeature from '../components/BundleKeyFeature';
import Button from '../components/Button';
import BuyingOptions from '../components/BuyingOptions';
import BOAddOnDeal from '../components/BuyingOptions/BOAddOnDeal';
import AddOnDealProductList from '../components/BuyingOptions/BOAddOnDeal/AddOnDealProductList';
import useAddOnDealReducer from '../components/BuyingOptions/BOAddOnDeal/useAddOnDealReducer';
import BOAddToCartButton from '../components/BuyingOptions/BOAddToCartButton';
import BOAdditionalOptions from '../components/BuyingOptions/BOAdditionalOptions';
import BOAdditionalOptionsList from '../components/BuyingOptions/BOAdditionalOptions/BOAdditionalOptionsList';
import BOConfirmDemoProduct from '../components/BuyingOptions/BOConfirmDemoProduct';
import BOFreeGifts from '../components/BuyingOptions/BOFreeGifts';
import BOFreeGiftsList from '../components/BuyingOptions/BOFreeGifts/BOFreeGiftsList';
import FreeGiftDeposit from '../components/BuyingOptions/BOFreeGifts/BOFreeGiftsList/FreeGiftDeposit';
import BOHeader from '../components/BuyingOptions/BOHeader';
import BOImages from '../components/BuyingOptions/BOImages';
import BOLabelItem from '../components/BuyingOptions/BOImages/BOLabelItem';
import BOLoading from '../components/BuyingOptions/BOLoading';
import BOPaymentInfo from '../components/BuyingOptions/BOPaymentInfo';
import AddToSalesOrderPopup from '../components/BuyingOptions/BOPaymentInfo/AddToSalesOrderPopup';
import BORentals from '../components/BuyingOptions/BORentals';
import BORentalsList from '../components/BuyingOptions/BORentals/BORentalsList';
import BOShippingInfo from '../components/BuyingOptions/BOShippingInfo';
import PickupFromStore from '../components/BuyingOptions/BOShippingInfo/PickupFromStore';
import AvailabilityStoresListModal from '../components/BuyingOptions/BOShippingInfo/PickupFromStore/AvailabilityStoresListModal';
import BOTradeIn from '../components/BuyingOptions/BOTradeIn';
import BOTradeInContent from '../components/BuyingOptions/BOTradeIn/BOTradeInContent';
import BOTradeInList from '../components/BuyingOptions/BOTradeIn/BOTradeInList';
import TradeInUploadImage from '../components/BuyingOptions/BOTradeIn/BOTradeInList/TradeInUploadImage';
import ImagesPreview from '../components/BuyingOptions/BOTradeIn/BOTradeInList/TradeInUploadImage/ImagesPreview';
import UploadImageButton from '../components/BuyingOptions/BOTradeIn/BOTradeInList/TradeInUploadImage/UploadImageButton';
import UploadImageErrorMessage from '../components/BuyingOptions/BOTradeIn/BOTradeInList/TradeInUploadImage/UploadImageErrorMessage';
import BOVariants from '../components/BuyingOptions/BOVariants';
import BOVariantsList from '../components/BuyingOptions/BOVariants/BOVariantsList';
import TermsConditionsModals from '../components/BuyingOptions/BOVariants/TermsConditionsModals';
import BOWarranty from '../components/BuyingOptions/BOWarranty';
import BOWarrantyList from '../components/BuyingOptions/BOWarranty/BOWarrantyList';
import CPContactInfo from '../components/CPContactInfo';
import CampaignBanner from '../components/CampaignBanner';
import CampaignProductListing from '../components/CampaignProductListing';
import CampaignProductListingItem from '../components/CampaignProductListing/CampaignProductListingItem';
import CampaignRegisterComponent from '../components/CampaignRegisterComponent';
import CalendarPicker from '../components/CampaignRegisterComponent/CalendarPicker';
import ChangeSchedule from '../components/CampaignRegisterComponent/ChangeSchedule';
import ChangeScheduleModal from '../components/CampaignRegisterComponent/ChangeSchedule/ChangeScheduleModal';
import DatePickerEvent from '../components/CampaignRegisterComponent/DatePickerEvent';
import LoginModalForm from '../components/CampaignRegisterComponent/LoginModalForm';
import RegisterEventForm from '../components/CampaignRegisterComponent/RegisterEventForm';
import EmailExistNotiModal from '../components/CampaignRegisterComponent/RegisterEventForm/EmailExistNotiModal';
import EnterOTPForm from '../components/CampaignRegisterComponent/RegisterEventForm/EnterOTPForm';
import UserInfoForm from '../components/CampaignRegisterComponent/RegisterEventForm/UserInfoForm';
import SelectStoreAndDate from '../components/CampaignRegisterComponent/SelectStoreAndDate';
import PolicyCheckbox from '../components/CampaignRegisterComponent/SelectStoreAndDate/PolicyCheckbox';
import QuestionsSelect from '../components/CampaignRegisterComponent/SelectStoreAndDate/QuestionsSelect';
import SelectPreferDate from '../components/CampaignRegisterComponent/SelectStoreAndDate/SelectPreferDate';
import SelectStore from '../components/CampaignRegisterComponent/SelectStoreAndDate/SelectStore';
import searchFilterStoreBar from '../components/CampaignRegisterComponent/SelectStoreAndDate/SelectStore/searchFilterStoreBar';
import filterStoreBtn from '../components/CampaignRegisterComponent/SelectStoreAndDate/SelectStore/searchFilterStoreBar/filterStoreBtn';
import CarDetailSuggestFreeShip from '../components/CarDetailSuggestFreeShip';
import CarouselWithIconBottom from '../components/CarouselWithIconBottom';
import CartSeller from '../components/CartSeller';
import CartSuggestFreeShip from '../components/CartSuggestFreeShip';
import CartSuggestDetailModal from '../components/CartSuggestFreeShip/CartSuggestDetailModal';
import CategoryBanner from '../components/CategoryLanding/CategoryBanner';
import FilterPopup from '../components/CategoryLanding/FilterPopup';
import FilterByFeature from '../components/CategoryLanding/FilterPopup/FilterByFeature';
import FilterByPrice from '../components/CategoryLanding/FilterPopup/FilterByPrice';
import FilterProductByColor from '../components/CategoryLanding/FilterPopup/FilterProductByColor';
import LoginRegisterModal from '../components/CategoryLanding/LoginRegisterModal';
import ProductListing from '../components/CategoryLanding/ProductListing';
import ProductListingItem from '../components/CategoryLanding/ProductListing/ProductListingItem';
import BookExperienceCta from '../components/CategoryLanding/ProductListing/ProductListingItem/BookExperienceCta';
import ProductListingItemLi from '../components/CategoryLanding/ProductListing/ProductListingItem/ProductListingItemLi';
import CenterBanner from '../components/CenterBanner';
import CartTotal from '../components/CheckoutPage/CartTotal';
import CheckoutPayment from '../components/CheckoutPage/CheckoutPayment';
import CheckoutReview from '../components/CheckoutPage/CheckoutReview';
import Coupon from '../components/CheckoutPage/Coupon';
import AccountChecking from '../components/CheckoutProcess/AccountChecking';
import GuestCheckout from '../components/CheckoutProcess/AccountChecking/GuestCheckout';
import FormGuestCheckout from '../components/CheckoutProcess/AccountChecking/GuestCheckout/FormGuestCheckout';
import PopupEmailAlready from '../components/CheckoutProcess/AccountChecking/PopupEmailAlready';
import ReturningCustomer from '../components/CheckoutProcess/AccountChecking/ReturningCustomer';
import FormReturningCustomer from '../components/CheckoutProcess/AccountChecking/ReturningCustomer/FormReturningCustomer';
import CheckoutSteps from '../components/CheckoutProcess/CheckoutSteps';
import CheckoutThankyou from '../components/CheckoutThankyou';
import CheckoutCreateAccount from '../components/CheckoutThankyou/CheckoutCreateAccount';
import TKPaymentDetail from '../components/CheckoutThankyou/TKPaymentDetail';
import TKPaymentStatus from '../components/CheckoutThankyou/TKPaymentStatus';
import ChosenBundle from '../components/ChosenBundle';
import ActivityLog from '../components/ClientPortal/Appointments/ActivityLog';
import AppointmentDetail from '../components/ClientPortal/Appointments/AppointmentDetail';
import AppointmentListing from '../components/ClientPortal/Appointments/AppointmentListing';
import AppointmentsListingTable from '../components/ClientPortal/Appointments/AppointmentListing/AppointmentsListingTable';
import DataTable from '../components/ClientPortal/Appointments/AppointmentListing/DataTable';
import AppointmentUpdate from '../components/ClientPortal/Appointments/AppointmentUpdate';
import AppointmentsButton from '../components/ClientPortal/Appointments/AppointmentsButton';
import AppointmentsInfor from '../components/ClientPortal/Appointments/AppointmentsInfor';
import EditAppointmentForm from '../components/ClientPortal/Appointments/EditAppointmentForm';
import QuestionComponent from '../components/ClientPortal/Appointments/EditAppointmentForm/QuestionComponent';
import SelectProductCP from '../components/ClientPortal/Appointments/EditAppointmentForm/SelectProductCP';
import SelectScentCP from '../components/ClientPortal/Appointments/EditAppointmentForm/SelectScentCP';
import SelectStatus from '../components/ClientPortal/Appointments/EditAppointmentForm/SelectStatus';
import SelectTeaCP from '../components/ClientPortal/Appointments/EditAppointmentForm/SelectTeaCP';
import CPConnectTask from '../components/ClientPortal/CPConnectTask';
import CPDOB from '../components/ClientPortal/CPDOB';
import CPDashboard from '../components/ClientPortal/CPDashboard';
import CPOverview from '../components/ClientPortal/CPDashboard/CPOverview';
import DashboardGroupLinks from '../components/ClientPortal/CPDashboard/DashboardGroupLinks';
import DashboardLink from '../components/ClientPortal/CPDashboard/DashboardLink';
import CPLogin from '../components/ClientPortal/CPLogin';
import CPLoginCheck from '../components/ClientPortal/CPLogin/CPLoginCheck';
import CPVerifyLogin from '../components/ClientPortal/CPLogin/CPVerifyLogin';
import CPPageHeader from '../components/ClientPortal/CPPageHeader';
import CPFilterPopup from '../components/ClientPortal/CPPageHeader/CPFilterPopup';
import CPFilterPopupOrders from '../components/ClientPortal/CPPageHeader/CPFilterPopupOrders';
import CPPaging from '../components/ClientPortal/CPPaging';
import CampaignQRCode from '../components/ClientPortal/CampaignQRCode';
import CampaignQRCodeItem from '../components/ClientPortal/CampaignQRCode/CampaignQRCodeItem';
import CategoriesNavigation from '../components/ClientPortal/CategoriesNavigation';
import CustomeWishlist from '../components/ClientPortal/CustomeWishlist';
import CustomerInterestPage from '../components/ClientPortal/CustomerInterestPage';
import CustomerProductList from '../components/ClientPortal/CustomerProductList';
import CPProductInfo from '../components/ClientPortal/CustomerProductList/CPProductInfo';
import CPProductListing from '../components/ClientPortal/CustomerProductList/CPProductListing';
import InfoHeader from '../components/ClientPortal/CustomerProductList/InfoHeader';
import CustomerProductPage from '../components/ClientPortal/CustomerProductPage';
import CustomerProfileListing from '../components/ClientPortal/CustomerProfileListing';
import CPSearchResult from '../components/ClientPortal/CustomerProfileListing/CPSearchResult';
import CustomerProfiles from '../components/ClientPortal/CustomerProfiles';
import BoxData from '../components/ClientPortal/CustomerProfiles/BoxData';
import ContactInfor from '../components/ClientPortal/CustomerProfiles/ContactInfor';
import CustomerLastVisit from '../components/ClientPortal/CustomerProfiles/CustomerLastVisit';
import CustomerProduct from '../components/ClientPortal/CustomerProfiles/CustomerProduct';
import CustomerProductInfo from '../components/ClientPortal/CustomerProfiles/CustomerProductInfo';
import CustomerProfileContainer from '../components/ClientPortal/CustomerProfiles/CustomerProfileContainer';
import CustomerSaleOrders from '../components/ClientPortal/CustomerProfiles/CustomerSaleOrders';
import SaleOrderItem from '../components/ClientPortal/CustomerProfiles/CustomerSaleOrders/SaleOrderItem';
import ViewAllSaleOrderModal from '../components/ClientPortal/CustomerProfiles/CustomerSaleOrders/ViewAllSaleOrderModal';
import CustomerVoucher from '../components/ClientPortal/CustomerProfiles/CustomerVoucher';
import CustomerWishlist from '../components/ClientPortal/CustomerProfiles/CustomerWishlist';
import ProductInterest from '../components/ClientPortal/CustomerProfiles/ProductInterest';
import Voucher from '../components/ClientPortal/CustomerProfiles/Voucher';
import CustomerWishlistPage from '../components/ClientPortal/CustomerWishlistPage';
import DemoLogic from '../components/ClientPortal/DemoLogic';
import EndDemo from '../components/ClientPortal/EndDemo';
import FinalReview from '../components/ClientPortal/FinalReview';
import WarningFinalReview from '../components/ClientPortal/FinalReview/WarningFinalReview';
import CPDemoStatus from '../components/ClientPortal/GenericComponents/CPDemoStatus';
import CPFooter from '../components/ClientPortal/GenericComponents/CPFooter';
import CPInput from '../components/ClientPortal/GenericComponents/CPForm/CPInput';
import CPSelect from '../components/ClientPortal/GenericComponents/CPForm/CPSelect';
import CPHeader from '../components/ClientPortal/GenericComponents/CPHeader';
import CPAccountQuickAccess from '../components/ClientPortal/GenericComponents/CPHeader/CPAccountQuickAccess';
import CPHeaderIconList from '../components/ClientPortal/GenericComponents/CPHeader/CPHeaderIconList';
import CPHeaderIcon from '../components/ClientPortal/GenericComponents/CPHeader/CPHeaderIconList/CPHeaderIcon';
import CPHeaderNotiIcon from '../components/ClientPortal/GenericComponents/CPHeader/CPHeaderIconList/CPHeaderNotiIcon';
import NotificationsContent from '../components/ClientPortal/GenericComponents/CPHeader/CPHeaderIconList/NotificationsContent';
import LoadingMore from '../components/ClientPortal/GenericComponents/CPHeader/CPHeaderIconList/NotificationsContent/LoadingMore';
import CPLanguageSelector from '../components/ClientPortal/GenericComponents/CPHeader/CPLanguageSelector';
import CPLogo from '../components/ClientPortal/GenericComponents/CPHeader/CPLogo';
import CPSearchBar from '../components/ClientPortal/GenericComponents/CPHeader/CPSearchBar';
import CPStoreSelector from '../components/ClientPortal/GenericComponents/CPHeader/CPStoreSelector';
import DemoSession from '../components/ClientPortal/GenericComponents/CPHeader/DemoSession';
import FilterRange from '../components/ClientPortal/GenericComponents/FilterRange';
import ProductInterestItem from '../components/ClientPortal/GenericComponents/ProductInterestItem';
import ProductInterestItemQuestionArea from '../components/ClientPortal/GenericComponents/ProductInterestItem/ProductInterestItemQuestionArea';
import ProductItemViewAll from '../components/ClientPortal/GenericComponents/ProductItemViewAll';
import LeadManagement from '../components/ClientPortal/LeadManagement';
import LeadInfo from '../components/ClientPortal/LeadManagement/LeadInfo';
import LeadManagementNoResult from '../components/ClientPortal/LeadManagement/LeadManagementNoResult';
import LeadSearch from '../components/ClientPortal/LeadManagement/LeadSearch';
import PurchaseOnTheSpot from '../components/ClientPortal/PurchaseOnTheSpot';
import QuickAccess from '../components/ClientPortal/QuickAccess';
import AccessItem from '../components/ClientPortal/QuickAccess/AccessItem';
import CustomeInfoPopup from '../components/ClientPortal/QuickAccess/CustomeInfoPopup';
import ExistingCustomerLifestyle from '../components/ClientPortal/QuickAccess/CustomeInfoPopup/ExistingCustomerLifestyle';
import CustomerAcknowledgePopup from '../components/ClientPortal/QuickAccess/CustomerAcknowledgePopup';
import AcknowledgeEmailInput from '../components/ClientPortal/QuickAccess/CustomerAcknowledgePopup/AcknowledgeEmailInput';
import CustomerInformationWarningPopup from '../components/ClientPortal/QuickAccess/CustomerAcknowledgePopup/CustomerInformationWarningPopup';
import ExistingCustomerInformation from '../components/ClientPortal/QuickAccess/CustomerAcknowledgePopup/ExistingCustomerInformation';
import ProductInterestPopup from '../components/ClientPortal/QuickAccess/ProductInterestPopup';
import ProductInterestAccordion from '../components/ClientPortal/QuickAccess/ProductInterestPopup/ProductInterestAccordion';
import QACustomerBasicProfile from '../components/ClientPortal/QuickAccess/QACustomerBasicProfile';
import QACustomerLifestyle from '../components/ClientPortal/QuickAccess/QACustomerLifestyle';
import QALink from '../components/ClientPortal/QuickAccess/QALink';
import QAProductInterestListing from '../components/ClientPortal/QuickAccess/QAProductInterestListing';
import QAWarningPopup from '../components/ClientPortal/QuickAccess/QAWarningPopup';
import QuickAccessPopup from '../components/ClientPortal/QuickAccess/QuickAccessPopup';
import ReviewCustomerInformation from '../components/ClientPortal/ReviewCustomerInformation';
import ReviewProductInterest from '../components/ClientPortal/ReviewProductInterest';
import SaleOrderStatuses from '../components/ClientPortal/SaleOrderStatuses';
import SaleOrdersListing from '../components/ClientPortal/SaleOrdersListing';
import CPPagingSaleOrderListing from '../components/ClientPortal/SaleOrdersListing/CPPagingSaleOrderListing';
import OrdersListing from '../components/ClientPortal/SaleOrdersListing/OrdersListing';
import OrdersSearch from '../components/ClientPortal/SaleOrdersListing/OrdersSearch';
import SaleOrdersListingNoResult from '../components/ClientPortal/SaleOrdersListing/SaleOrdersListingNoResult';
import SaveSaleOrderSuccess from '../components/ClientPortal/SaveSaleOrderSuccess';
import SaveSOSuccessBody from '../components/ClientPortal/SaveSaleOrderSuccess/SaveSOSuccessBody';
import SaveSOSuccessFooter from '../components/ClientPortal/SaveSaleOrderSuccess/SaveSOSuccessFooter';
import SaveSOSuccessHeader from '../components/ClientPortal/SaveSaleOrderSuccess/SaveSOSuccessHeader';
import SendOrderToCustomer from '../components/ClientPortal/SendOrderToCustomer';
import EventCheckbox from '../components/ClientPortal/SendOrderToCustomer/EventCheckbox';
import ItemCheckbox from '../components/ClientPortal/SendOrderToCustomer/ItemCheckbox';
import SendOrderToCustomerModal from '../components/ClientPortal/SendOrderToCustomer/SendOrderToCustomerModal';
import SendOrderToCustomerWarningModal from '../components/ClientPortal/SendOrderToCustomer/SendOrderToCustomerWarningModal';
import SendSaleOrderSuccess from '../components/ClientPortal/SendSaleOrderSuccess';
import CommissionFactoryScript from '../components/CommissionFactoryScript';
import CompareProducts from '../components/CompareProducts';
import CompareProductItem from '../components/CompareProducts/CompareProductItem';
import CompareProductLayout from '../components/CompareProducts/CompareProductLayout';
import CompareProductsForPDP from '../components/CompareProducts/CompareProductsForPDP';
import ProductFunctionsDetail from '../components/CompareProducts/ProductFunctionsDetail';
import GeneralFunctions from '../components/CompareProducts/ProductFunctionsDetail/GeneralFunctions';
import Layout from '../components/CompareProducts/ProductFunctionsDetail/Layout';
import ProductPreview from '../components/CompareProducts/ProductPreview';
import ProductSelect from '../components/CompareProducts/ProductSelect';
import RecentlyProductItem from '../components/CompareProducts/RecentlyProductItem';
import ContentSharing from '../components/ContentSharing';
import CookieBanner from '../components/CookieBanner';
import CouponWallet from '../components/CouponWallet';
import CouponWalletDetailPopup from '../components/CouponWallet/CouponWalletDetailPopup';
import CouponWalletListPopup from '../components/CouponWallet/CouponWalletListPopup';
import DesktopCouponWalletItem from '../components/CouponWallet/DesktopCouponWalletItem';
import MobileCouponWalletItem from '../components/CouponWallet/MobileCouponWalletItem';
import DeliverySpecialRewards from '../components/DeliverySpecialRewards';
import DynamicBundleHeader from '../components/DynamicBundleHeader';
import EmarsysScript from '../components/EmarsysScript';
import EmbeddedHtmlCollection from '../components/EmbeddedHtmlCollection';
import ErrorComponent from '../components/ErrorComponent';
import Form from '../components/Form';
import CustomFieldFactory from '../components/Form/SitecoreForm/CustomFieldFactory';
import CustomReCaptchaComponent from '../components/Form/SitecoreForm/CustomReCaptchaComponent';
import CustomButton from '../components/Form/SitecoreForm/FieldTypes/CustomButton';
import CustomCheckbox from '../components/Form/SitecoreForm/FieldTypes/CustomCheckbox';
import CustomCheckboxList from '../components/Form/SitecoreForm/FieldTypes/CustomCheckboxList';
import CustomDropdownList from '../components/Form/SitecoreForm/FieldTypes/CustomDropdownList';
import CustomInputTypeFile from '../components/Form/SitecoreForm/FieldTypes/CustomInputTypeFile';
import CustomLabel from '../components/Form/SitecoreForm/FieldTypes/CustomLabel';
import CustomMultipleLineText from '../components/Form/SitecoreForm/FieldTypes/CustomMultipleLineText';
import CustomRadioboxList from '../components/Form/SitecoreForm/FieldTypes/CustomRadioboxList';
import CustomRangeRadioList from '../components/Form/SitecoreForm/FieldTypes/CustomRangeRadioList';
import CustomResponseMsg from '../components/Form/SitecoreForm/FieldTypes/CustomResponseMsg';
import CustomRichTextCheckbox from '../components/Form/SitecoreForm/FieldTypes/CustomRichTextCheckbox';
import CustomRichTextFormField from '../components/Form/SitecoreForm/FieldTypes/CustomRichTextFormField';
import CustomSingleLineText from '../components/Form/SitecoreForm/FieldTypes/CustomSingleLineText';
import CustomTelephone from '../components/Form/SitecoreForm/FieldTypes/CustomTelephone';
import EmailValidator from '../components/Form/SitecoreForm/FieldTypes/EmailValidator';
import HiddenField from '../components/Form/SitecoreForm/FieldTypes/HiddenField';
import FormFieldAllError from '../components/Form/SitecoreForm/FormFieldAllError';
import FormFieldError from '../components/Form/SitecoreForm/FormFieldError';
import LabelComponentForm from '../components/Form/SitecoreForm/LabelComponentForm';
import FreeGiftPopup from '../components/FreeGiftPopup';
import AutomaticallyAddedGift from '../components/FreeGiftPopup/AutomaticallyAddedGift';
import FreeGiftItem from '../components/FreeGiftPopup/FreeGiftItem';
import FreeGiftPopupLayout from '../components/FreeGiftPopup/FreeGiftPopupLayout';
import SelectingFreeGift from '../components/FreeGiftPopup/SelectingFreeGift';
import FreeGiftSelectionBody from '../components/FreeGiftPopup/SelectingFreeGift/FreeGiftSelectionBody';
import FreeGiftSelectionItem from '../components/FreeGiftPopup/SelectingFreeGift/FreeGiftSelectionItem';
import SelectingFreeGiftProvider from '../components/FreeGiftPopup/SelectingFreeGiftProvider';
import FulfillmentOptions from '../components/FulfillmentOptions';
import ContinuePaymentBtn from '../components/FulfillmentOptions/ContinuePaymentBtn';
import DeliveryComponent from '../components/FulfillmentOptions/DeliveryComponent';
import BillingAddressComponent from '../components/FulfillmentOptions/DeliveryComponent/BillingAddressComponent';
import CartSellerComponent from '../components/FulfillmentOptions/DeliveryComponent/CartSellerComponent';
import CouponAppliedComponent from '../components/FulfillmentOptions/DeliveryComponent/CouponAppliedComponent';
import PickUpFromStoreList from '../components/FulfillmentOptions/DeliveryComponent/PickUpFromStoreList';
import ProductListComponent from '../components/FulfillmentOptions/DeliveryComponent/ProductListComponent';
import ProductListItem from '../components/FulfillmentOptions/DeliveryComponent/ProductListComponent/ProductListItem';
import StoreAddressComponent from '../components/FulfillmentOptions/DeliveryComponent/StoreAddressComponent';
import UserAddressComponent from '../components/FulfillmentOptions/DeliveryComponent/UserAddressComponent';
import SelectAddressPopup from '../components/FulfillmentOptions/DeliveryComponent/UserAddressComponent/SelectAddressPopup';
import RequireChangeFulfillmentOption from '../components/FulfillmentOptions/RequireChangeFulfillmentOption';
import FullWidthAutoLoopVideo from '../components/FullWidthAutoLoopVideo';
import HeaderScript from '../components/HeaderScript';
import HelpMeDecide from '../components/HelpMeDecide';
import HelpMeDecideResult from '../components/HelpMeDecideResult';
import HelpMeDecideBookExperienceCta from '../components/HelpMeDecideResult/ItemResult/HelpMeDecideBookExperienceCta';
import Image from '../components/Image';
import JotForm from '../components/JotForm';
import Link from '../components/Link';
import LoyaltyLandingPageTable from '../components/LoyaltyLandingPageTable';
import LoyaltyTable from '../components/LoyaltyLandingPageTable/LoyaltyTable';
import LoyaltyTableContent from '../components/LoyaltyLandingPageTable/LoyaltyTableContent';
import EventRegistration from '../components/MemberEvent/EventRegistration';
import FormWrapper from '../components/MemberEvent/EventRegistration/FormWrapper';
import InformationForm from '../components/MemberEvent/EventRegistration/InformationForm';
import LocationForm from '../components/MemberEvent/EventRegistration/LocationForm';
import LocationStoreItem from '../components/MemberEvent/EventRegistration/LocationForm/LocationStoreItem';
import MultiStepForm from '../components/MemberEvent/EventRegistration/MultiStepForm';
import MemberEventCancel from '../components/MemberEvent/MemberEventCancel';
import MemberEventChange from '../components/MemberEvent/MemberEventChange';
import MemberEventDetail from '../components/MemberEvent/MemberEventDetail';
import EventBannerSwiper from '../components/MemberEvent/MemberEventDetail/EventBannerSwiper';
import LocationSwiper from '../components/MemberEvent/MemberEventDetail/LocationSwiper';
import MemberEventListing from '../components/MemberEvent/MemberEventListing';
import EventItem from '../components/MemberEvent/MemberEventListing/EventItem';
import MemberEventRegisteredOrChanged from '../components/MemberEvent/MemberEventRegisteredOrChanged';
import MemberEventsWidget from '../components/MemberEvent/MemberEventsWidget';
import MyAppointment from '../components/MemberEvent/MyAppointment';
import CancelMyAppointmentModal from '../components/MemberEvent/MyAppointment/CancelMyAppointmentModal';
import Metadata from '../components/Metadata';
import MonthDiscountedItems from '../components/MonthDiscountedItems';
import MonthDiscountedSwiper from '../components/MonthDiscountedItems/MonthDiscountedSwiper';
import MyReviews from '../components/MyReviews';
import MyRewardsWidget from '../components/MyRewardsWidget';
import IsMemberLoyalty from '../components/MyRewardsWidget/IsMemberLoyalty';
import IsNotMemberLoyalty from '../components/MyRewardsWidget/IsNotMemberLoyalty';
import MyRewardWidgetLayout from '../components/MyRewardsWidget/MyRewardWidgetLayout';
import NewsletterPopup from '../components/NewsletterPopup';
import NewsletterForm from '../components/NewsletterPopup/components/NewsletterForm';
import OneColumn from '../components/PageStructure/OneColumn';
import TwoColumn11 from '../components/PageStructure/TwoColumn11';
import FAQFrequentlyCTA from '../components/PageStructure/TwoColumn11/FAQFrequentlyCTA';
import WarrantyRegistrationCTA from '../components/PageStructure/TwoColumn11/WarrantyRegistrationCTA';
import TwoColumn41 from '../components/PageStructure/TwoColumn41';
import PartnerSpecial from '../components/PartnerSpecial';
import PartnerSpecialDetailsSwiper from '../components/PartnerSpecial/PartnerSpecialDetailsSwiper';
import PartnerSpecialModal from '../components/PartnerSpecial/PartnerSpecialModal';
import PartnerSpecialsLanding from '../components/PartnerSpecialsLanding';
import PartnerSpecialDetailAccordion from '../components/PartnerSpecialsLanding/PartnerSpecialDetailAccordion';
import PartnerSpecialsDetailLogo from '../components/PartnerSpecialsLanding/PartnerSpecialsDetailLogo';
import PaymentFail from '../components/PaymentFail';
import PaymentOptions from '../components/PaymentOptions';
import PaymentProcessing from '../components/PaymentProcessing';
import OfferDetails from '../components/PersonalizedOffer/OfferDetails';
import CartDetailsSection from '../components/PersonalizedOffer/OfferDetails/CartDetailsSection';
import OfferDetailsWidget from '../components/PersonalizedOffer/OfferDetails/OfferDetailsWidget';
import PersonalizedOfferWidget from '../components/PersonalizedOffer/PersonalizedOfferWidget';
import ProductInfoSection from '../components/PersonalizedOffer/PersonalizedOfferWidget/ProductInfoSection';
import PersonalizedOffersWidget from '../components/PersonalizedOffer/PersonalizedOffersWidget';
import LazyLoading from '../components/PersonalizedOffer/PersonalizedOffersWidget/LazyLoading';
import PersonalizedOffersWidgetBody from '../components/PersonalizedOffer/PersonalizedOffersWidget/PersonalizedOffersWidgetBody';
import PersonalizedOffersWidgetProvider from '../components/PersonalizedOffer/PersonalizedOffersWidget/PersonalizedOffersWidgetProvider';
import PopupBanner from '../components/PopupBanner';
import AddToViewHistory from '../components/Product/AddToViewHistory';
import ContentSharingPlaceholder from '../components/Product/ContentSharingPlaceholder';
import FreeGift from '../components/Product/FreeGift';
import FreeGiftInfomationPopup from '../components/Product/FreeGift/FreeGiftInfomationPopup';
import MyWishlist from '../components/Product/MyWishlist';
import ProductWishlistItem from '../components/Product/MyWishlist/ProductWishlistItem';
import ProductAlsoBought from '../components/Product/ProductAlsoBought';
import ProductContainer from '../components/Product/ProductContainer';
import ProductDetailSpec from '../components/Product/ProductDetailSpec';
import BackrestMassageUnit from '../components/Product/ProductDetailSpec/BackrestMassageUnit';
import Deminsion from '../components/Product/ProductDetailSpec/Deminsion';
import FootrestMassageUnit from '../components/Product/ProductDetailSpec/FootrestMassageUnit';
import ModelSpec from '../components/Product/ProductDetailSpec/ModelSpec';
import SeatMassageUnit from '../components/Product/ProductDetailSpec/SeatMassageUnit';
import WightModel from '../components/Product/ProductDetailSpec/WightModel';
import ProductItemView from '../components/Product/ProductItemView';
import ProductOverview from '../components/Product/ProductOverview';
import ProductRecommendation from '../components/Product/ProductRecommendation';
import ProductRecommendationItem from '../components/Product/ProductRecommendation/ProductRecommendationItem';
import RelatedSpecialDeal from '../components/Product/RelatedSpecialDeal';
import ProductSpecialDealsItem from '../components/Product/RelatedSpecialDeal/ProductSpecialDealsItem';
import VariantDetail from '../components/Product/VariantDetail';
import ProductDescription from '../components/Product/VariantDetail/ProductDescription';
import ProductDetailHeader from '../components/Product/VariantDetail/ProductDetailHeader';
import CategoryProductItem from '../components/Product/VariantDetail/ProductDetailHeader/CategoryProductItem';
import NotifyMePopup from '../components/Product/VariantDetail/ProductDetailHeader/NotifyMePopup';
import ProductDetailHeaderBundle from '../components/Product/VariantDetail/ProductDetailHeader/ProductDetailHeaderBundle';
import ProductDetailHeaderDynamicBundle from '../components/Product/VariantDetail/ProductDetailHeader/ProductDetailHeaderDynamicBundle';
import ProductDetailHeaderMenu from '../components/Product/VariantDetail/ProductDetailHeader/ProductDetailHeaderMenu';
import ProductHeaderPrice from '../components/Product/VariantDetail/ProductDetailHeader/ProductHeaderPrice';
import ProductDetailOverview from '../components/Product/VariantDetail/ProductDetailOverview';
import CustomPaginationSwiper from '../components/Product/VariantDetail/ProductDetailOverview/CustomPaginationSwiper';
import ProductVariantImage from '../components/Product/VariantDetail/ProductDetailOverview/ProductVariantImage';
import ProductVariantInfo from '../components/Product/VariantDetail/ProductDetailOverview/ProductVariantInfo';
import termsConditionsModal from '../components/Product/VariantDetail/ProductDetailOverview/ProductVariantInfo/termsConditionsModal';
import SwiperComponentZoom from '../components/Product/VariantDetail/ProductDetailOverview/SwiperComponentZoom';
import ProductImages from '../components/Product/VariantDetail/ProductImages';
import ProductImagesItem from '../components/Product/VariantDetail/ProductImages/ProductImagesItem';
import ProductImagesMenu from '../components/Product/VariantDetail/ProductImages/ProductImagesMenu';
import ProductPrice from '../components/Product/VariantDetail/ProductPrice';
import ProductVariants from '../components/Product/VariantDetail/ProductVariants';
import ProductAddedToCart from '../components/ProductAddedToCart';
import ProductCardPrice from '../components/ProductCardPrice';
import ProductCatalogue from '../components/ProductCatalogue';
import ProductCatalogueItem from '../components/ProductCatalogue/ProductCatalogueItem';
import ProductCountdownTimer from '../components/ProductCountdownTimer';
import ProductInstallmentCalculate from '../components/ProductInstallmentCalculate';
import ArticleCarousel from '../components/ProductResource/ProductResourceDetail/ArticleCarousel';
import CarouselDetailSlide from '../components/ProductResource/ProductResourceDetail/CarouselDetailSlide';
import MobileApp from '../components/ProductResource/ProductResourceDetail/MobileApp';
import CarouselImage from '../components/ProductResource/ProductResourceDetail/MobileApp/CarouselImage';
import ListApp from '../components/ProductResource/ProductResourceDetail/MobileApp/ListApp';
import ProductManual from '../components/ProductResource/ProductResourceDetail/ProductManual';
import CarouselItem from '../components/ProductResource/ProductResourceList/CarouselItem';
import CarouselWithItemTitle from '../components/ProductResource/ProductResourceList/CarouselWithItemTitle';
import ProductHubInfo from '../components/ProductResource/ProductResourceList/ProductHubInfo';
import ProductResourceListing from '../components/ProductResource/ProductResourceList/ProductResourceListing';
import ResourceListing from '../components/ProductResource/ProductResourceList/ResourceListing';
import MyProducts from '../components/ProductWarrantyRegistration/MyProducts';
import WarrantyProductItem from '../components/ProductWarrantyRegistration/MyProducts/WarrantyProductItem';
import MyProductsWidget from '../components/ProductWarrantyRegistration/MyProductsWidget';
import ProductDetail from '../components/ProductWarrantyRegistration/ProductDetail';
import ProductWarrantyDetail from '../components/ProductWarrantyRegistration/ProductWarrantyDetail';
import DownloadAppItemWidget from '../components/ProductWarrantyRegistration/ProductWarrantyDetail/DownloadAppItemWidget';
import DownloadOSIMAppDetail from '../components/ProductWarrantyRegistration/ProductWarrantyDetail/DownloadOSIMAppDetail';
import ProductReviewItemWidget from '../components/ProductWarrantyRegistration/ProductWarrantyDetail/ProductReviewItemWidget';
import RegistrationErrorPopup from '../components/ProductWarrantyRegistration/RegistrationErrorPopup';
import RemoveProductCTA from '../components/ProductWarrantyRegistration/RemoveProductCTA';
import WarrantyDetail from '../components/ProductWarrantyRegistration/WarrantyDetail';
import WarrantyRegisterLogin from '../components/ProductWarrantyRegistration/WarrantyRegisterLogin';
import WarrantyLoginForm from '../components/ProductWarrantyRegistration/WarrantyRegisterLogin/WarrantyLoginForm';
import WarrantyRegisterForm from '../components/ProductWarrantyRegistration/WarrantyRegisterLogin/WarrantyRegisterForm';
import WarrantyRegistration from '../components/ProductWarrantyRegistration/WarrantyRegistration';
import CategorySelect from '../components/ProductWarrantyRegistration/WarrantyRegistration/CategorySelect';
import DatePicker from '../components/ProductWarrantyRegistration/WarrantyRegistration/DatePicker';
import DatePurchase from '../components/ProductWarrantyRegistration/WarrantyRegistration/DatePurchase';
import OrderNumberInput from '../components/ProductWarrantyRegistration/WarrantyRegistration/OrderNumberInput';
import ProductWarrantySelect from '../components/ProductWarrantyRegistration/WarrantyRegistration/ProductWarrantySelect';
import SerialNumberInput from '../components/ProductWarrantyRegistration/WarrantyRegistration/SerialNumberInput';
import useWarrantyRegistrationFormik from '../components/ProductWarrantyRegistration/WarrantyRegistration/hooks/useWarrantyRegistrationFormik';
import WarrantyRegistrationProcess from '../components/ProductWarrantyRegistration/WarrantyRegistrationProcess';
import WarrantyRegistrationThankYou from '../components/ProductWarrantyRegistration/WarrantyRegistrationThankYou';
import DiscoverProductButton from '../components/ProductWarrantyRegistration/WarrantyRegistrationThankYou/DiscoverProductButton';
import ProductPreviewSubmitted from '../components/ProductWarrantyRegistration/WarrantyRegistrationThankYou/ProductPreviewSubmitted';
import ProductWarrantySubmitted from '../components/ProductWarrantyRegistration/WarrantyRegistrationThankYou/ProductWarrantySubmitted';
import WarrantyRegistrationThankYouDescription from '../components/ProductWarrantyRegistration/WarrantyRegistrationThankYou/WarrantyRegistrationThankYouDescription';
import PromotionDetailBundle from '../components/PromotionDetailBundle';
import CreateBundle from '../components/PromotionDetailBundle/CreateBundle';
import BundleItems from '../components/PromotionDetailBundle/CreateBundle/BundleItems';
import DynamicBundleElements from '../components/PromotionDetailBundle/DynamicBundleElements';
import PromotionDetailBundleItem from '../components/PromotionDetailBundle/DynamicBundleElements/PromotionDetailBundleItem';
import PromotionDetailBundleSwiper from '../components/PromotionDetailBundle/PromotionDetailBundleSwiper';
import PromotionHeader from '../components/PromotionHeader';
import PromotionListing from '../components/PromotionListing';
import PromotionListingItem from '../components/PromotionListing/PromotionListingItem';
import RawText from '../components/RawText';
import RecentlyViewedProducts from '../components/RecentlyViewedProducts';
import RecentlyViewedProductItem from '../components/RecentlyViewedProducts/RecentlyViewedProductItem';
import RelatedFreeGift from '../components/RelatedFreeGift';
import ResponsiveImage from '../components/ResponsiveImage';
import ReviewPage from '../components/ReviewPage';
import FullReviewListing from '../components/ReviewPage/FullReviewListing';
import LimitedReviewListing from '../components/ReviewPage/LimitedReviewListing';
import MyProductDetailReview from '../components/ReviewPage/MyProductDetailReview';
import MyProductReview from '../components/ReviewPage/MyProductReview';
import ProductReview from '../components/ReviewPage/ProductReview';
import ReviewInput from '../components/ReviewPage/ProductReview/ReviewInput';
import SubmitReviewProcess from '../components/ReviewPage/ProductReview/SubmitReviewProcess';
import ProductReviewContent from '../components/ReviewPage/ProductReviewContent';
import ProductReviewForPDP from '../components/ReviewPage/ProductReviewForPDP';
import NavigationBundleProduct from '../components/ReviewPage/ProductReviewForPDP/NavigationBundleProduct';
import ProductReviewListing from '../components/ReviewPage/ProductReviewListing';
import ProductReviewSubmitted from '../components/ReviewPage/ProductReviewSubmitted';
import ReviewMedia from '../components/ReviewPage/ReviewMedia';
import ReviewMediaPopup from '../components/ReviewPage/ReviewMediaPopup';
import ReviewStarRating from '../components/ReviewPage/ReviewStarRating';
import ReviewsSummary from '../components/ReviewPage/ReviewsSummary';
import UploadMultipleFiles from '../components/ReviewPage/UploadMultipleFiles';
import VideoFile from '../components/ReviewPage/UploadMultipleFiles/VideoFile';
import PolicySearchResult from '../components/Search/PolicySearchResult';
import PolicySearchResultItem from '../components/Search/PolicySearchResult/PolicySearchResultItem';
import ProductSearchResult from '../components/Search/ProductSearchResult';
import ProductSearchResultFilterPopup from '../components/Search/ProductSearchResult/ProductSearchResultFilterPopup';
import ProductSearchResultFilterColor from '../components/Search/ProductSearchResult/ProductSearchResultFilterPopup/ProductSearchResultFilterColor';
import ProductSearchResultFilterFeature from '../components/Search/ProductSearchResult/ProductSearchResultFilterPopup/ProductSearchResultFilterFeature';
import ProductSearchResultFilterPrice from '../components/Search/ProductSearchResult/ProductSearchResultFilterPopup/ProductSearchResultFilterPrice';
import ProductSearchResultItem from '../components/Search/ProductSearchResult/ProductSearchResultItem';
import ResourceSearchItem from '../components/Search/ProductSearchResult/ResourceSearchItem';
import AdditionalFullFilmentOption from '../components/Share/AdditionalFullFilmentOption';
import AutoCompleteUI from '../components/Share/AutoCompleteUI';
import Breadcrumb from '../components/Share/Breadcrumb';
import BuyingAccordion from '../components/Share/BuyingAccordion';
import BuyingFirstTypeHeader from '../components/Share/BuyingAccordion/BuyingFirstTypeHeader';
import BuyingSecondTypeHeader from '../components/Share/BuyingAccordion/BuyingSecondTypeHeader';
import BuyingTueTypeHeader from '../components/Share/BuyingAccordion/BuyingTueTypeHeader';
import BuyingBundleAccordion from '../components/Share/BuyingBundleAccordion';
import BundleBOFirstTypeHeader from '../components/Share/BuyingBundleAccordion/BundleBOFirstTypeHeader';
import BundleBOSecondTypeHeader from '../components/Share/BuyingBundleAccordion/BundleBOSecondTypeHeader';
import CheckBox from '../components/Share/CheckBox';
import CountdownTimer from '../components/Share/CountdownTimer';
import CountdownTimerCampaign from '../components/Share/CountdownTimer/CountdownTimerCampaign';
import CountdownTimerItem from '../components/Share/CountdownTimer/CountdownTimerItem';
import CountdownTimerResend from '../components/Share/CountdownTimerResend';
import DynamicStripAds from '../components/Share/DynamicStripAds';
import ExperienceEditorError from '../components/Share/ExperienceEditorError';
import Footer from '../components/Share/Footer';
import IconList from '../components/Share/Footer/IconList';
import IconItem from '../components/Share/Footer/IconList/IconItem';
import LanguageSelector from '../components/Share/Footer/LanguageSelector';
import LanguageItem from '../components/Share/Footer/LanguageSelector/LanguageItem';
import FooterNavigation from '../components/Share/FooterNavigation';
import FooterNavigationItem from '../components/Share/FooterNavigation/FooterNavigationItem';
import FooterNavigationList from '../components/Share/FooterNavigation/FooterNavigationItem/FooterNavigationList';
import FooterNavigationTitle from '../components/Share/FooterNavigation/FooterNavigationItem/FooterNavigationTitle';
import GoogleAnalytic from '../components/Share/GoogleAnalytic';
import Header from '../components/Share/Header';
import AccountQuickAccess from '../components/Share/Header/AccountQuickAccess';
import CatalogueNavigation from '../components/Share/Header/CatalogueNavigation';
import MainNavigationSubItem from '../components/Share/Header/CatalogueNavigation/MainNavigationSubItem';
import MainNavigationSubMenu from '../components/Share/Header/CatalogueNavigation/MainNavigationSubMenu';
import VerticalTabLayout from '../components/Share/Header/CatalogueNavigation/MainNavigationSubMenu/VerticalTabLayout';
import VerticalTabExtraLinkItem from '../components/Share/Header/CatalogueNavigation/MainNavigationSubMenu/VerticalTabLayout/VerticalTabExtraLinkItem';
import VerticalTabItem from '../components/Share/Header/CatalogueNavigation/MainNavigationSubMenu/VerticalTabLayout/VerticalTabItem';
import Hambuger from '../components/Share/Header/Hambuger';
import HeaderMenu from '../components/Share/Header/HeaderMenu';
import IconNavigation from '../components/Share/Header/IconNavigation';
import IconNavigationItem from '../components/Share/Header/IconNavigation/IconNavigationItem';
import Logo from '../components/Share/Header/Logo';
import MiniCart from '../components/Share/Header/MiniCart';
import CartMiniItem from '../components/Share/Header/MiniCart/CartMiniItem';
import CartMiniTotalAmount from '../components/Share/Header/MiniCart/CartMiniTotalAmount';
import QuickNavigation from '../components/Share/Header/QuickNavigation';
import QuickNavigationItem from '../components/Share/Header/QuickNavigation/QuickNavigationItem';
import SearchBox from '../components/Share/Header/SearchBox';
import SearchBoxInput from '../components/Share/Header/SearchBox/SearchBoxInput';
import SearchBoxInputSuggestList from '../components/Share/Header/SearchBox/SearchBoxInput/SearchBoxInputSuggestList';
import HighlightedText from '../components/Share/HighlightedText';
import InfoStockComponent from '../components/Share/InfoStockComponent';
import InstagramAuthorization from '../components/Share/InstagramAuthorization';
import Loading from '../components/Share/Loading';
import LoadingMask from '../components/Share/LoadingMask';
import LoadingShimmer from '../components/Share/LoadingShimmer';
import Message from '../components/Share/Message';
import MissingDataApi from '../components/Share/MissingDataApi';
import ModalComponent from '../components/Share/ModalComponent';
import OmnichatTracking from '../components/Share/OmnichatTracking';
import OsimCheckBox from '../components/Share/OsimCheckBox';
import Pagination from '../components/Share/Pagination';
import PhoneNumberSelect from '../components/Share/PhoneNumberSelect';
import PlainHTML from '../components/Share/PlainHTML';
import Popup from '../components/Share/Popup';
import RichText from '../components/Share/RichText';
import FormSubmitErrorPopup from '../components/Share/RichText/FormSubmitErrorPopup';
import SocialNavigation from '../components/Share/SocialNavigation';
import SocialNavigationItem from '../components/Share/SocialNavigation/SocialNavigationItem';
import StoreLocator from '../components/Share/StoreLocator';
import StoreLocatorContent from '../components/Share/StoreLocator/StoreLocatorContent';
import GoogleMap from '../components/Share/StoreLocator/StoreLocatorContent/GoogleMap';
import StoreLocatorBar from '../components/Share/StoreLocator/StoreLocatorContent/StoreLocatorBar';
import StoreLocatorFilterIcon from '../components/Share/StoreLocator/StoreLocatorContent/StoreLocatorBar/StoreLocatorFilterIcon';
import StoreLocatorFilterModal from '../components/Share/StoreLocator/StoreLocatorContent/StoreLocatorBar/StoreLocatorFilterIcon/StoreLocatorFilterModal';
import StoreLocatorFilterPopup from '../components/Share/StoreLocator/StoreLocatorContent/StoreLocatorBar/StoreLocatorFilterIcon/StoreLocatorFilterPopup';
import StoreLocatorFilterPopupContent from '../components/Share/StoreLocator/StoreLocatorContent/StoreLocatorBar/StoreLocatorFilterIcon/StoreLocatorFilterPopupContent';
import StoreLocatorSearch from '../components/Share/StoreLocator/StoreLocatorContent/StoreLocatorBar/StoreLocatorSearch';
import StoreLocatorList from '../components/Share/StoreLocator/StoreLocatorContent/StoreLocatorList';
import StoreLocatorListItem from '../components/Share/StoreLocator/StoreLocatorContent/StoreLocatorList/StoreLocatorListItem';
import StripAds from '../components/Share/StripAds';
import SwipeComponent from '../components/Share/SwipeComponent';
import SwipeWithThumbnailComponent from '../components/Share/SwipeWithThumbnailComponent';
import PreviewComponent from '../components/Share/SwipeWithThumbnailComponent/PreviewComponent';
import ThumbnailComponent from '../components/Share/SwipeWithThumbnailComponent/ThumbnailComponent';
import TabComponent from '../components/Share/TabComponent';
import ToggleWisList from '../components/Share/ToggleWisList';
import VideoPlayer from '../components/Share/VideoPlayer';
import PlayerControl from '../components/Share/VideoPlayer/PlayerControl';
import WechatAuthorization from '../components/Share/WechatAuthorization';
import YahooAuthorization from '../components/Share/YahooAuthorization';
import ShowInformationTiers from '../components/ShowInformationTiers';
import Authentication from '../components/SingleSignOn/Authentication';
import DateOfBirth from '../components/SingleSignOn/DateOfBirth';
import FacebookSSO from '../components/SingleSignOn/FacebookSSO';
import ForgotPassword from '../components/SingleSignOn/ForgotPassword';
import GoogleSSO from '../components/SingleSignOn/GoogleSSO';
import InstagramSSO from '../components/SingleSignOn/InstagramSSO';
import LogoutComponent from '../components/SingleSignOn/LogoutComponent';
import NewPassword from '../components/SingleSignOn/NewPassword';
import PasswordHint from '../components/SingleSignOn/PasswordHint';
import PasswordInput from '../components/SingleSignOn/PasswordInput';
import RegisterLogin from '../components/SingleSignOn/RegisterLogin';
import Login from '../components/SingleSignOn/RegisterLogin/Login';
import Register from '../components/SingleSignOn/RegisterLogin/Register';
import RegisterActiveMail from '../components/SingleSignOn/RegisterLogin/RegisterActiveMail';
import TaskListAuthen from '../components/SingleSignOn/TaskListAuthen';
import WechatSSO from '../components/SingleSignOn/WechatSSO';
import YahooSSO from '../components/SingleSignOn/YahooSSO';
import InfoBox from '../components/SlicingPage/About/BrandStory/InfoBox';
import TimelinePanel from '../components/SlicingPage/About/BrandStory/TimelinePanel';
import Carousel from '../components/SlicingPage/About/Carousel';
import ZoomSwiperComponent from '../components/SlicingPage/About/Carousel/ZoomSwiperComponent';
import ZoomSwiperComponentItem from '../components/SlicingPage/About/Carousel/ZoomSwiperComponent/ZoomSwiperComponentItem';
import ExpertPopupContent from '../components/SlicingPage/About/OurWellnessTeam/ExpertPopupContent';
import SimpleSquareTiles from '../components/SlicingPage/About/OurWellnessTeam/SimpleSquareTiles';
import SimpleSquareItem from '../components/SlicingPage/About/OurWellnessTeam/SimpleSquareTiles/SimpleSquareItem';
import AddToCart from '../components/SlicingPage/AddToCart';
import BackToTop from '../components/SlicingPage/BackToTop';
import BalanceDetails from '../components/SlicingPage/BanlancePayment/BalanceDetails';
import BalanceDetailModals from '../components/SlicingPage/BanlancePayment/BalanceDetails/BalanceDetailModals';
import CarouselWidthIcon from '../components/SlicingPage/BrandStory/CarouselWidthIcon';
import CarouselWidthIconBottom from '../components/SlicingPage/BrandStory/CarouselWidthIcon/CarouselWidthIconBottom';
import CarouselWidthIconTop from '../components/SlicingPage/BrandStory/CarouselWidthIcon/CarouselWidthIconTop';
import CartDetails from '../components/SlicingPage/CartDetails';
import CartDetailModal from '../components/SlicingPage/CartDetails/CartDetailModal';
import CartEmty from '../components/SlicingPage/CartDetails/CartEmty';
import CartFulfilmentOption from '../components/SlicingPage/CartDetails/CartFulfilmentOption';
import CartHeadInfo from '../components/SlicingPage/CartDetails/CartHeadInfo';
import CartList from '../components/SlicingPage/CartDetails/CartList';
import CartItem from '../components/SlicingPage/CartDetails/CartList/CartItem';
import CPEditProductBtn from '../components/SlicingPage/CartDetails/CartList/CartItem/CPEditProductBtn';
import CartAdditionalOptionItem from '../components/SlicingPage/CartDetails/CartList/CartItem/CartAdditionalOptionItem';
import CartItemDelivery from '../components/SlicingPage/CartDetails/CartList/CartItem/CartItemDelivery';
import CartItemFreeGift from '../components/SlicingPage/CartDetails/CartList/CartItem/CartItemFreeGift';
import CartItemGiftingOption from '../components/SlicingPage/CartDetails/CartList/CartItem/CartItemGiftingOption';
import CartItemInfor from '../components/SlicingPage/CartDetails/CartList/CartItem/CartItemInfor';
import CartItemTotalPrice from '../components/SlicingPage/CartDetails/CartList/CartItem/CartItemTotalPrice';
import CartRentalItem from '../components/SlicingPage/CartDetails/CartList/CartItem/CartRentalItem';
import CartTradeInItem from '../components/SlicingPage/CartDetails/CartList/CartItem/CartTradeInItem';
import CartWarrantyItem from '../components/SlicingPage/CartDetails/CartList/CartItem/CartWarrantyItem';
import ConfirmRemoveCart from '../components/SlicingPage/CartDetails/CartList/CartItem/ConfirmRemoveCart';
import ListItemSwiper from '../components/SlicingPage/CartDetails/CartList/CartItem/ListItemSwiper';
import PromotionCart from '../components/SlicingPage/CartDetails/CartList/CartItem/PromotionCart';
import CartMilstone from '../components/SlicingPage/CartDetails/CartMilstone';
import CartPromotionCodes from '../components/SlicingPage/CartDetails/CartPromotionCodes';
import AppliedCouponItem from '../components/SlicingPage/CartDetails/CartPromotionCodes/AppliedCouponItem';
import BaseCouponItem from '../components/SlicingPage/CartDetails/CartPromotionCodes/BaseCouponItem';
import PopUpCouponItem from '../components/SlicingPage/CartDetails/CartPromotionCodes/PopUpCouponItem';
import CartStripAds from '../components/SlicingPage/CartDetails/CartStripAds';
import CartSummary from '../components/SlicingPage/CartDetails/CartSummary';
import OfferAppliedModal from '../components/SlicingPage/CartDetails/CartSummary/OfferAppliedModal';
import SelectArealModalContentData from '../components/SlicingPage/CartDetails/CartSummary/SelectArealModalContentData';
import DeleteSaleOrderButton from '../components/SlicingPage/CartDetails/CartSummary/SelectArealModalContentData/DeleteSaleOrderButton';
import SFExpressPopup from '../components/SlicingPage/CartDetails/SFExpressPopup';
import SFExpressPopupItem from '../components/SlicingPage/CartDetails/SFExpressPopup/SFExpressPopupItem';
import ContactUs from '../components/SlicingPage/ContactUs';
import ContactUsIconList from '../components/SlicingPage/ContactUs/ContactUsIconList';
import ContactUsIconListItem from '../components/SlicingPage/ContactUs/ContactUsIconListItem';
import ContactUsCTA from '../components/SlicingPage/ContactUsCTA';
import Banner from '../components/SlicingPage/HomePage/Banner';
import CountDownBanner from '../components/SlicingPage/HomePage/Banner/CountDownBanner';
import FeaturedProducts from '../components/SlicingPage/HomePage/FeaturedProducts';
import FeaturedProductItem from '../components/SlicingPage/HomePage/FeaturedProducts/FeaturedProductItem';
import FeaturedProductItemLi from '../components/SlicingPage/HomePage/FeaturedProducts/FeaturedProductItem/FeaturedProductItemLi';
import FeaturedTiles from '../components/SlicingPage/HomePage/FeaturedTiles';
import FeaturedTilesItem from '../components/SlicingPage/HomePage/FeaturedTiles/FeaturedTilesItem';
import SimpleTiles from '../components/SlicingPage/HomePage/SimpleTiles';
import SimpleTilesItem from '../components/SlicingPage/HomePage/SimpleTiles/SimpleTilesItem';
import SliderBanners from '../components/SlicingPage/HomePage/SliderBanners';
import SliderBannersItem from '../components/SlicingPage/HomePage/SliderBanners/SliderBannersItem';
import TwoColumnCTAButton from '../components/SlicingPage/HomePage/TwoColumnCTAButton';
import MyAccount from '../components/SlicingPage/MyAccount';
import AccountSettings from '../components/SlicingPage/MyAccount/AccountSettings';
import ChangePassword from '../components/SlicingPage/MyAccount/AccountSettings/ChangePassword';
import ChangePasswordSuccess from '../components/SlicingPage/MyAccount/AccountSettings/ChangePassword/ChangePasswordSuccess';
import ContactInformation from '../components/SlicingPage/MyAccount/AccountSettings/ContactInformation';
import ContactInformationWidget from '../components/SlicingPage/MyAccount/AccountSettings/ContactInformationWidget';
import ForgotEmail from '../components/SlicingPage/MyAccount/AccountSettings/ForgotEmail';
import ChangeEmail from '../components/SlicingPage/MyAccount/AccountSettings/ForgotEmail/ChangeEmail';
import VerifyThroughEmail from '../components/SlicingPage/MyAccount/AccountSettings/ForgotEmail/VerifyThroughEmail';
import VerifyThroughOldEmail from '../components/SlicingPage/MyAccount/AccountSettings/ForgotEmail/VerifyThroughOldEmail';
import NewsletterPreferenceWidget from '../components/SlicingPage/MyAccount/AccountSettings/NewsletterPreferenceWidget';
import PasswordManagementWidget from '../components/SlicingPage/MyAccount/AccountSettings/PasswordManagementWidget';
import SocialLoginsWidget from '../components/SlicingPage/MyAccount/AccountSettings/SocialLoginsWidget';
import AddressesWidget from '../components/SlicingPage/MyAccount/AddressesWidget';
import AddressesDefault from '../components/SlicingPage/MyAccount/AddressesWidget/AddressesDefault';
import AppointmentBookedComponent from '../components/SlicingPage/MyAccount/AppointmentBookedComponent';
import RegisterAccountForm from '../components/SlicingPage/MyAccount/AppointmentBookedComponent/RegisterAccountForm';
import AppointmentDetails from '../components/SlicingPage/MyAccount/AppointmentDetails';
import AppointmentDetailContent from '../components/SlicingPage/MyAccount/AppointmentDetails/AppointmentDetailContent';
import CancelAppointment from '../components/SlicingPage/MyAccount/AppointmentDetails/CancelAppointment';
import CancelAppointmentModal from '../components/SlicingPage/MyAccount/AppointmentDetails/CancelAppointmentModal';
import BookExperienceButtonComponent from '../components/SlicingPage/MyAccount/BookExperienceButtonComponent';
import MyAddress from '../components/SlicingPage/MyAccount/MyAddress';
import AddNewAddress from '../components/SlicingPage/MyAccount/MyAddress/AddNewAddress';
import AddressBook from '../components/SlicingPage/MyAccount/MyAddress/AddressBook';
import AddressForMultiLanguage from '../components/SlicingPage/MyAccount/MyAddress/AddressForMultiLanguage';
import AddressItem from '../components/SlicingPage/MyAccount/MyAddress/AddressItem';
import BillingAddress from '../components/SlicingPage/MyAccount/MyAddress/BillingAddress';
import ChangeBillingAddress from '../components/SlicingPage/MyAccount/MyAddress/BillingAddress/ChangeBillingAddress';
import ConfirmRemoveAddress from '../components/SlicingPage/MyAccount/MyAddress/ConfirmRemoveAddress';
import EditAddressBookPopup from '../components/SlicingPage/MyAccount/MyAddress/EditAddressBookPopup';
import InfoAddress from '../components/SlicingPage/MyAccount/MyAddress/InfoAddress';
import ShippingAddress from '../components/SlicingPage/MyAccount/MyAddress/ShippingAddress';
import ChangeShippingAddress from '../components/SlicingPage/MyAccount/MyAddress/ShippingAddress/ChangeShippingAddress';
import MyAppointments from '../components/SlicingPage/MyAccount/MyAppointments';
import MyAppointmentsWidget from '../components/SlicingPage/MyAccount/MyAppointmentsWidget';
import MyOrders from '../components/SlicingPage/MyAccount/MyOrders';
import MyOrdersWidget from '../components/SlicingPage/MyAccount/MyOrdersWidget';
import MyWishlistWidget from '../components/SlicingPage/MyAccount/MyWishlistWidget';
import OrderDetails from '../components/SlicingPage/MyAccount/OrderDetails';
import OrderInfo from '../components/SlicingPage/MyAccount/OrderDetails/OrderInfo';
import PaymentMethodComponent from '../components/SlicingPage/MyAccount/OrderDetails/PaymentMethodComponent';
import SpecialRequestComponent from '../components/SlicingPage/MyAccount/OrderDetails/SpecialRequestComponent';
import TotalOrder from '../components/SlicingPage/MyAccount/OrderDetails/TotalOrder';
import model from '../components/SlicingPage/MyAccount/OrderDetails/TotalOrder/model';
import PersonalProfileWidget from '../components/SlicingPage/MyAccount/PersonalProfileWidget';
import SupportCentreWidget from '../components/SlicingPage/MyAccount/SupportCentreWidget';
import PaymentMethod from '../components/SlicingPage/PaymentMethod';
import ProductBanner from '../components/SlicingPage/ProductDetailPage/ProductBanner';
import SimpleCards from '../components/SlicingPage/ProductDetailPage/SimpleCards';
import SimpleCardItem from '../components/SlicingPage/ProductDetailPage/SimpleCards/SimpleCardItem';
import SubNavigation from '../components/SlicingPage/ProductDetailPage/SubNavigation';
import SubNavigationItem from '../components/SlicingPage/ProductDetailPage/SubNavigation/SubNavigationItem';
import ProductSupportCTA from '../components/SlicingPage/ProductSupportCTA';
import ProductCategorySwiper from '../components/SlicingPage/ProductSupportCTA/ProductCategorySwiper';
import ProductSwiper from '../components/SlicingPage/ProductSupportCTA/ProductSwiper';
import PurchaseOnSpot from '../components/SlicingPage/PurchaseOnSpot';
import PurchaseOnSpotCompleted from '../components/SlicingPage/PurchaseOnSpot/PurchaseOnSpotCompleted';
import ExploreOSIMProducts from '../components/SlicingPage/StoreDetail/ExploreOSIMProducts';
import FeaturedCategories from '../components/SlicingPage/StoreDetail/FeaturedCategories';
import InfoBoxWithImage from '../components/SlicingPage/StoreDetail/InfoBoxWithImage';
import StoreExperiences from '../components/SlicingPage/StoreDetail/StoreExperiences';
import StoreOverview from '../components/SlicingPage/StoreDetail/StoreOverview';
import SlideUpBanner from '../components/SlideUpBanner';
import SpecialRelatedProduct from '../components/SpecialRelatedProduct';
import SpecialRelatedProductItem from '../components/SpecialRelatedProduct/SpecialRelatedProductItem';
import SpinAndWin from '../components/SpinAndWin';
import ApplyOfferPopup from '../components/SpinAndWin/ApplyOfferPopup';
import ChanceToWinPopup from '../components/SpinAndWin/ChanceToWinPopup';
import GiftUnavailable from '../components/SpinAndWin/GiftUnavailable';
import HelpIcon from '../components/SpinAndWin/HelpIcon';
import HowToPlayPopup from '../components/SpinAndWin/HowToPlayPopup';
import MyPrizesPopup from '../components/SpinAndWin/MyPrizesPopup';
import PrizesIcon from '../components/SpinAndWin/PrizesIcon';
import SpinWinBanner from '../components/SpinAndWin/Spin&WinBanner';
import SpinWinHeading from '../components/SpinAndWin/Spin&WinHeading';
import SpinAndWinComponent from '../components/SpinAndWin/SpinAndWinComponent';
import SpinAndWinContext from '../components/SpinAndWin/SpinAndWinContext';
import SpinAndWinPopUp from '../components/SpinAndWin/SpinAndWinPopUp';
import SpinCouponInfoPopup from '../components/SpinAndWin/SpinCouponInfoPopup';
import SpinCouponItem from '../components/SpinAndWin/SpinCouponItem';
import SpinForm from '../components/SpinAndWin/SpinForm';
import SpinWheel from '../components/SpinAndWin/SpinWheel';
import SpinWinPopup from '../components/SpinAndWin/SpinWinPopup';
import SpinWinners from '../components/SpinAndWin/SpinWinners';
import ViewMyPrizesButton from '../components/SpinAndWin/ViewMyPrizesButton';
import StoreHeader from '../components/StoreHeader';
import DownloadOsimApp from '../components/SupportCentre/DownloadOsimApp';
import ProductAccessories from '../components/SupportCentre/ProductAccessories';
import ProductManualDownload from '../components/SupportCentre/ProductManualDownload';
import SimpleCTA from '../components/SupportCentre/SimpleCTA';
import SupportCenterTitle from '../components/SupportCentre/SupportCenterTitle';
import TaxMessageDetail from '../components/TaxMessageDetail';
import ThreeColumnBanner from '../components/ThreeColumnBanner';
import TierBenefit from '../components/TierBenefit';
import TierBenefitAnchor from '../components/TierBenefitAnchor';
import Title from '../components/Title';
import TradeInSpecialRewards from '../components/TradeInSpecialRewards';
import TradeInSpecialRewardsItem from '../components/TradeInSpecialRewards/TradeInSpecialRewardsItem';
import TradeInSpecialRewardsSwiper from '../components/TradeInSpecialRewards/TradeInSpecialRewardsSwiper';
import TwoColumnImage from '../components/TwoColumnImage';
import TwoColumnImageWithAccodion from '../components/TwoColumnImageWithAccodion';
import TwoColumnImageWithAccodionItem from '../components/TwoColumnImageWithAccodion/TwoColumnImageWithAccodionItem';
import TwoColumnWithTextImage from '../components/TwoColumnWithTextImage';
import Typography from '../components/Typography';
import UniversalSearchBox from '../components/UniversalSearchBox';
import Unsubscribe from '../components/Unsubscribe';
import Video from '../components/Video';
import VisitedCategoryPage from '../components/VisitedCategoryPage';
import VisitedProductPage from '../components/VisitedProductPage';
import BannerWithRichTextOverlay from '../components/Wellness/BannerWithRichTextOverlay';
import FeaturedArticle from '../components/Wellness/FeaturedArticle';
import FeaturedArticleItem from '../components/Wellness/FeaturedArticle/FeaturedArticleItem';
import LatestArticle from '../components/Wellness/LatestArticle';
import OtherWellnessContents from '../components/Wellness/OtherWellnessContents';
import SearchBoxArticle from '../components/Wellness/SearchBoxArticle';
import SingleFeaturedProduct from '../components/Wellness/SingleFeaturedProduct';
import WellBeingProducts from '../components/Wellness/WellBeingProducts';
import WellBeingProductItem from '../components/Wellness/WellBeingProducts/WellBeingProductItem';
import WellnessArticleItem from '../components/Wellness/WellnessArticle/WellnessArticleItem';
import WellnessContents from '../components/Wellness/WellnessContents';
import WellnessDetailHeader from '../components/Wellness/WellnessDetailHeader';
import WellnessDetailHeaderTagItem from '../components/Wellness/WellnessDetailHeader/WellnessDetailHeaderTagItem';
import WellnessFilterTag from '../components/Wellness/WellnessFilterTag';
import WellnessListing from '../components/Wellness/WellnessListing';
import WellnessListingItem from '../components/Wellness/WellnessListing/WellnessListingItem';
import WellnessListingSearch from '../components/Wellness/WellnessListing/WellnessListingSearch';
import WhyChooseOsim from '../components/WhyChooseOsim';
import YourProductHubDetail from '../components/YourProductHubDetail';
import ProductHubItem from '../components/YourProductHubDetail/ProductHubItem';
import CategoryLanding from '../layout/CategoryLanding';

const components = new Map();
components.set('AbandonedCartWidget', AbandonedCartWidget);
components.set('ViewCartButton', ViewCartButton);
components.set('Accordion', Accordion);
components.set('AccordionItem', AccordionItem);
components.set('AnimatedBanner', AnimatedBanner);
components.set('AnimatedBannerWithImages', AnimatedBannerWithImages);
components.set('AnimatedBannerWithVideo', AnimatedBannerWithVideo);
components.set('AppointmentBooked', AppointmentBooked);
components.set('AutoScrollingBanners', AutoScrollingBanners);
components.set('Marquee', Marquee);
components.set('BannerWithPopup', BannerWithPopup);
components.set('PopoverItem', PopoverItem);
components.set('BannerWithText', BannerWithText);
components.set('BirthdayRewards', BirthdayRewards);
components.set('ModalNeedAddProduct', ModalNeedAddProduct);
components.set('BookExperienceComponent', BookExperienceComponent);
components.set('SelectProduct', SelectProduct);
components.set('ScheduleAppointmentComponent', ScheduleAppointmentComponent);
components.set('FormikStep', FormikStep);
components.set('ContactDetailsForm', ContactDetailsForm);
components.set('ContactDetailSubtitle', ContactDetailSubtitle);
components.set('EmailExistModal', EmailExistModal);
components.set('ErrorHandlerComp', ErrorHandlerComp);
components.set('FormLayout', FormLayout);
components.set('InputForm', InputForm);
components.set('LoginModal', LoginModal);
components.set('OTPInputHandler', OTPInputHandler);
components.set('PolicyAndTermCheckbox', PolicyAndTermCheckbox);
components.set('PersonalizeExperienceForm', PersonalizeExperienceForm);
components.set('AdditionalSelection', AdditionalSelection);
components.set('SelectScent', SelectScent);
components.set('SelectTea', SelectTea);
components.set('ScheduleAppointmentForm', ScheduleAppointmentForm);
components.set('SelectDate', SelectDate);
components.set('SelectStoreSchedule', SelectStoreSchedule);
components.set('searchScheduleFilterStoreBar', searchScheduleFilterStoreBar);
components.set('filterStoreScheduleBtn', filterStoreScheduleBtn);
components.set('SelectTimeSlotAndGuest', SelectTimeSlotAndGuest);
components.set('ProgressBar', ProgressBar);
components.set('UpdateAppointmentSuccessPopup', UpdateAppointmentSuccessPopup);
components.set('BundleBuyingOption', BundleBuyingOption);
components.set('BundleBuyingOptionLayout', BundleBuyingOptionLayout);
components.set('BundleBOAddToCartButton', BundleBOAddToCartButton);
components.set('BundleBOAdditionalOptions', BundleBOAdditionalOptions);
components.set('BundleBOAdditionalOptionsList', BundleBOAdditionalOptionsList);
components.set('BundleBOFreeGifts', BundleBOFreeGifts);
components.set('BundleBOFreeGiftList', BundleBOFreeGiftList);
components.set('BundleBOHeader', BundleBOHeader);
components.set('BundleBOImages', BundleBOImages);
components.set('BundleBOLabels', BundleBOLabels);
components.set('BundleBOPaymentInfo', BundleBOPaymentInfo);
components.set('BundleBOShippingInfo', BundleBOShippingInfo);
components.set('BundleBOVariants', BundleBOVariants);
components.set('BundleBOVariantsList', BundleBOVariantsList);
components.set('BundleBOWarranty', BundleBOWarranty);
components.set('BundleBOWarrantyList', BundleBOWarrantyList);
components.set('BundleElements', BundleElements);
components.set('LabelItem', LabelItem);
components.set('BundleKeyFeature', BundleKeyFeature);
components.set('Button', Button);
components.set('BuyingOptions', BuyingOptions);
components.set('BOAddOnDeal', BOAddOnDeal);
components.set('AddOnDealProductList', AddOnDealProductList);
components.set('useAddOnDealReducer', useAddOnDealReducer);
components.set('BOAddToCartButton', BOAddToCartButton);
components.set('BOAdditionalOptions', BOAdditionalOptions);
components.set('BOAdditionalOptionsList', BOAdditionalOptionsList);
components.set('BOConfirmDemoProduct', BOConfirmDemoProduct);
components.set('BOFreeGifts', BOFreeGifts);
components.set('BOFreeGiftsList', BOFreeGiftsList);
components.set('FreeGiftDeposit', FreeGiftDeposit);
components.set('BOHeader', BOHeader);
components.set('BOImages', BOImages);
components.set('BOLabelItem', BOLabelItem);
components.set('BOLoading', BOLoading);
components.set('BOPaymentInfo', BOPaymentInfo);
components.set('AddToSalesOrderPopup', AddToSalesOrderPopup);
components.set('BORentals', BORentals);
components.set('BORentalsList', BORentalsList);
components.set('BOShippingInfo', BOShippingInfo);
components.set('PickupFromStore', PickupFromStore);
components.set('AvailabilityStoresListModal', AvailabilityStoresListModal);
components.set('BOTradeIn', BOTradeIn);
components.set('BOTradeInContent', BOTradeInContent);
components.set('BOTradeInList', BOTradeInList);
components.set('TradeInUploadImage', TradeInUploadImage);
components.set('ImagesPreview', ImagesPreview);
components.set('UploadImageButton', UploadImageButton);
components.set('UploadImageErrorMessage', UploadImageErrorMessage);
components.set('BOVariants', BOVariants);
components.set('BOVariantsList', BOVariantsList);
components.set('TermsConditionsModals', TermsConditionsModals);
components.set('BOWarranty', BOWarranty);
components.set('BOWarrantyList', BOWarrantyList);
components.set('CPContactInfo', CPContactInfo);
components.set('CampaignBanner', CampaignBanner);
components.set('CampaignProductListing', CampaignProductListing);
components.set('CampaignProductListingItem', CampaignProductListingItem);
components.set('CampaignRegisterComponent', CampaignRegisterComponent);
components.set('CalendarPicker', CalendarPicker);
components.set('ChangeSchedule', ChangeSchedule);
components.set('ChangeScheduleModal', ChangeScheduleModal);
components.set('DatePickerEvent', DatePickerEvent);
components.set('LoginModalForm', LoginModalForm);
components.set('RegisterEventForm', RegisterEventForm);
components.set('EmailExistNotiModal', EmailExistNotiModal);
components.set('EnterOTPForm', EnterOTPForm);
components.set('UserInfoForm', UserInfoForm);
components.set('SelectStoreAndDate', SelectStoreAndDate);
components.set('PolicyCheckbox', PolicyCheckbox);
components.set('QuestionsSelect', QuestionsSelect);
components.set('SelectPreferDate', SelectPreferDate);
components.set('SelectStore', SelectStore);
components.set('searchFilterStoreBar', searchFilterStoreBar);
components.set('filterStoreBtn', filterStoreBtn);
components.set('CarDetailSuggestFreeShip', CarDetailSuggestFreeShip);
components.set('CarouselWithIconBottom', CarouselWithIconBottom);
components.set('CartSeller', CartSeller);
components.set('CartSuggestFreeShip', CartSuggestFreeShip);
components.set('CartSuggestDetailModal', CartSuggestDetailModal);
components.set('CategoryBanner', CategoryBanner);
components.set('FilterPopup', FilterPopup);
components.set('FilterByFeature', FilterByFeature);
components.set('FilterByPrice', FilterByPrice);
components.set('FilterProductByColor', FilterProductByColor);
components.set('LoginRegisterModal', LoginRegisterModal);
components.set('ProductListing', ProductListing);
components.set('ProductListingItem', ProductListingItem);
components.set('BookExperienceCta', BookExperienceCta);
components.set('ProductListingItemLi', ProductListingItemLi);
components.set('CenterBanner', CenterBanner);
components.set('CartTotal', CartTotal);
components.set('CheckoutPayment', CheckoutPayment);
components.set('CheckoutReview', CheckoutReview);
components.set('Coupon', Coupon);
components.set('AccountChecking', AccountChecking);
components.set('GuestCheckout', GuestCheckout);
components.set('FormGuestCheckout', FormGuestCheckout);
components.set('PopupEmailAlready', PopupEmailAlready);
components.set('ReturningCustomer', ReturningCustomer);
components.set('FormReturningCustomer', FormReturningCustomer);
components.set('CheckoutSteps', CheckoutSteps);
components.set('CheckoutThankyou', CheckoutThankyou);
components.set('CheckoutCreateAccount', CheckoutCreateAccount);
components.set('TKPaymentDetail', TKPaymentDetail);
components.set('TKPaymentStatus', TKPaymentStatus);
components.set('ChosenBundle', ChosenBundle);
components.set('ActivityLog', ActivityLog);
components.set('AppointmentDetail', AppointmentDetail);
components.set('AppointmentListing', AppointmentListing);
components.set('AppointmentsListingTable', AppointmentsListingTable);
components.set('DataTable', DataTable);
components.set('AppointmentUpdate', AppointmentUpdate);
components.set('AppointmentsButton', AppointmentsButton);
components.set('AppointmentsInfor', AppointmentsInfor);
components.set('EditAppointmentForm', EditAppointmentForm);
components.set('QuestionComponent', QuestionComponent);
components.set('SelectProductCP', SelectProductCP);
components.set('SelectScentCP', SelectScentCP);
components.set('SelectStatus', SelectStatus);
components.set('SelectTeaCP', SelectTeaCP);
components.set('CPConnectTask', CPConnectTask);
components.set('CPDOB', CPDOB);
components.set('CPDashboard', CPDashboard);
components.set('CPOverview', CPOverview);
components.set('DashboardGroupLinks', DashboardGroupLinks);
components.set('DashboardLink', DashboardLink);
components.set('CPLogin', CPLogin);
components.set('CPLoginCheck', CPLoginCheck);
components.set('CPVerifyLogin', CPVerifyLogin);
components.set('CPPageHeader', CPPageHeader);
components.set('CPFilterPopup', CPFilterPopup);
components.set('CPFilterPopupOrders', CPFilterPopupOrders);
components.set('CPPaging', CPPaging);
components.set('CampaignQRCode', CampaignQRCode);
components.set('CampaignQRCodeItem', CampaignQRCodeItem);
components.set('CategoriesNavigation', CategoriesNavigation);
components.set('CustomeWishlist', CustomeWishlist);
components.set('CustomerInterestPage', CustomerInterestPage);
components.set('CustomerProductList', CustomerProductList);
components.set('CPProductInfo', CPProductInfo);
components.set('CPProductListing', CPProductListing);
components.set('InfoHeader', InfoHeader);
components.set('CustomerProductPage', CustomerProductPage);
components.set('CustomerProfileListing', CustomerProfileListing);
components.set('CPSearchResult', CPSearchResult);
components.set('CustomerProfiles', CustomerProfiles);
components.set('BoxData', BoxData);
components.set('ContactInfor', ContactInfor);
components.set('CustomerLastVisit', CustomerLastVisit);
components.set('CustomerProduct', CustomerProduct);
components.set('CustomerProductInfo', CustomerProductInfo);
components.set('CustomerProfileContainer', CustomerProfileContainer);
components.set('CustomerSaleOrders', CustomerSaleOrders);
components.set('SaleOrderItem', SaleOrderItem);
components.set('ViewAllSaleOrderModal', ViewAllSaleOrderModal);
components.set('CustomerVoucher', CustomerVoucher);
components.set('CustomerWishlist', CustomerWishlist);
components.set('ProductInterest', ProductInterest);
components.set('Voucher', Voucher);
components.set('CustomerWishlistPage', CustomerWishlistPage);
components.set('DemoLogic', DemoLogic);
components.set('EndDemo', EndDemo);
components.set('FinalReview', FinalReview);
components.set('WarningFinalReview', WarningFinalReview);
components.set('CPDemoStatus', CPDemoStatus);
components.set('CPFooter', CPFooter);
components.set('CPInput', CPInput);
components.set('CPSelect', CPSelect);
components.set('CPHeader', CPHeader);
components.set('CPAccountQuickAccess', CPAccountQuickAccess);
components.set('CPHeaderIconList', CPHeaderIconList);
components.set('CPHeaderIcon', CPHeaderIcon);
components.set('CPHeaderNotiIcon', CPHeaderNotiIcon);
components.set('NotificationsContent', NotificationsContent);
components.set('LoadingMore', LoadingMore);
components.set('CPLanguageSelector', CPLanguageSelector);
components.set('CPLogo', CPLogo);
components.set('CPSearchBar', CPSearchBar);
components.set('CPStoreSelector', CPStoreSelector);
components.set('DemoSession', DemoSession);
components.set('FilterRange', FilterRange);
components.set('ProductInterestItem', ProductInterestItem);
components.set('ProductInterestItemQuestionArea', ProductInterestItemQuestionArea);
components.set('ProductItemViewAll', ProductItemViewAll);
components.set('LeadManagement', LeadManagement);
components.set('LeadInfo', LeadInfo);
components.set('LeadManagementNoResult', LeadManagementNoResult);
components.set('LeadSearch', LeadSearch);
components.set('PurchaseOnTheSpot', PurchaseOnTheSpot);
components.set('QuickAccess', QuickAccess);
components.set('AccessItem', AccessItem);
components.set('CustomeInfoPopup', CustomeInfoPopup);
components.set('ExistingCustomerLifestyle', ExistingCustomerLifestyle);
components.set('CustomerAcknowledgePopup', CustomerAcknowledgePopup);
components.set('AcknowledgeEmailInput', AcknowledgeEmailInput);
components.set('CustomerInformationWarningPopup', CustomerInformationWarningPopup);
components.set('ExistingCustomerInformation', ExistingCustomerInformation);
components.set('ProductInterestPopup', ProductInterestPopup);
components.set('ProductInterestAccordion', ProductInterestAccordion);
components.set('QACustomerBasicProfile', QACustomerBasicProfile);
components.set('QACustomerLifestyle', QACustomerLifestyle);
components.set('QALink', QALink);
components.set('QAProductInterestListing', QAProductInterestListing);
components.set('QAWarningPopup', QAWarningPopup);
components.set('QuickAccessPopup', QuickAccessPopup);
components.set('ReviewCustomerInformation', ReviewCustomerInformation);
components.set('ReviewProductInterest', ReviewProductInterest);
components.set('SaleOrderStatuses', SaleOrderStatuses);
components.set('SaleOrdersListing', SaleOrdersListing);
components.set('CPPagingSaleOrderListing', CPPagingSaleOrderListing);
components.set('OrdersListing', OrdersListing);
components.set('OrdersSearch', OrdersSearch);
components.set('SaleOrdersListingNoResult', SaleOrdersListingNoResult);
components.set('SaveSaleOrderSuccess', SaveSaleOrderSuccess);
components.set('SaveSOSuccessBody', SaveSOSuccessBody);
components.set('SaveSOSuccessFooter', SaveSOSuccessFooter);
components.set('SaveSOSuccessHeader', SaveSOSuccessHeader);
components.set('SendOrderToCustomer', SendOrderToCustomer);
components.set('EventCheckbox', EventCheckbox);
components.set('ItemCheckbox', ItemCheckbox);
components.set('SendOrderToCustomerModal', SendOrderToCustomerModal);
components.set('SendOrderToCustomerWarningModal', SendOrderToCustomerWarningModal);
components.set('SendSaleOrderSuccess', SendSaleOrderSuccess);
components.set('CommissionFactoryScript', CommissionFactoryScript);
components.set('CompareProducts', CompareProducts);
components.set('CompareProductItem', CompareProductItem);
components.set('CompareProductLayout', CompareProductLayout);
components.set('CompareProductsForPDP', CompareProductsForPDP);
components.set('ProductFunctionsDetail', ProductFunctionsDetail);
components.set('GeneralFunctions', GeneralFunctions);
components.set('Layout', Layout);
components.set('ProductPreview', ProductPreview);
components.set('ProductSelect', ProductSelect);
components.set('RecentlyProductItem', RecentlyProductItem);
components.set('ContentSharing', ContentSharing);
components.set('CookieBanner', CookieBanner);
components.set('CouponWallet', CouponWallet);
components.set('CouponWalletDetailPopup', CouponWalletDetailPopup);
components.set('CouponWalletListPopup', CouponWalletListPopup);
components.set('DesktopCouponWalletItem', DesktopCouponWalletItem);
components.set('MobileCouponWalletItem', MobileCouponWalletItem);
components.set('DeliverySpecialRewards', DeliverySpecialRewards);
components.set('DynamicBundleHeader', DynamicBundleHeader);
components.set('EmarsysScript', EmarsysScript);
components.set('EmbeddedHtmlCollection', EmbeddedHtmlCollection);
components.set('ErrorComponent', ErrorComponent);
components.set('Form', Form);
components.set('CustomFieldFactory', CustomFieldFactory);
components.set('CustomReCaptchaComponent', CustomReCaptchaComponent);
components.set('CustomButton', CustomButton);
components.set('CustomCheckbox', CustomCheckbox);
components.set('CustomCheckboxList', CustomCheckboxList);
components.set('CustomDropdownList', CustomDropdownList);
components.set('CustomInputTypeFile', CustomInputTypeFile);
components.set('CustomLabel', CustomLabel);
components.set('CustomMultipleLineText', CustomMultipleLineText);
components.set('CustomRadioboxList', CustomRadioboxList);
components.set('CustomRangeRadioList', CustomRangeRadioList);
components.set('CustomResponseMsg', CustomResponseMsg);
components.set('CustomRichTextCheckbox', CustomRichTextCheckbox);
components.set('CustomRichTextFormField', CustomRichTextFormField);
components.set('CustomSingleLineText', CustomSingleLineText);
components.set('CustomTelephone', CustomTelephone);
components.set('EmailValidator', EmailValidator);
components.set('HiddenField', HiddenField);
components.set('FormFieldAllError', FormFieldAllError);
components.set('FormFieldError', FormFieldError);
components.set('LabelComponentForm', LabelComponentForm);
components.set('FreeGiftPopup', FreeGiftPopup);
components.set('AutomaticallyAddedGift', AutomaticallyAddedGift);
components.set('FreeGiftItem', FreeGiftItem);
components.set('FreeGiftPopupLayout', FreeGiftPopupLayout);
components.set('SelectingFreeGift', SelectingFreeGift);
components.set('FreeGiftSelectionBody', FreeGiftSelectionBody);
components.set('FreeGiftSelectionItem', FreeGiftSelectionItem);
components.set('SelectingFreeGiftProvider', SelectingFreeGiftProvider);
components.set('FulfillmentOptions', FulfillmentOptions);
components.set('ContinuePaymentBtn', ContinuePaymentBtn);
components.set('DeliveryComponent', DeliveryComponent);
components.set('BillingAddressComponent', BillingAddressComponent);
components.set('CartSellerComponent', CartSellerComponent);
components.set('CouponAppliedComponent', CouponAppliedComponent);
components.set('PickUpFromStoreList', PickUpFromStoreList);
components.set('ProductListComponent', ProductListComponent);
components.set('ProductListItem', ProductListItem);
components.set('StoreAddressComponent', StoreAddressComponent);
components.set('UserAddressComponent', UserAddressComponent);
components.set('SelectAddressPopup', SelectAddressPopup);
components.set('RequireChangeFulfillmentOption', RequireChangeFulfillmentOption);
components.set('FullWidthAutoLoopVideo', FullWidthAutoLoopVideo);
components.set('HeaderScript', HeaderScript);
components.set('HelpMeDecide', HelpMeDecide);
components.set('HelpMeDecideResult', HelpMeDecideResult);
components.set('HelpMeDecideBookExperienceCta', HelpMeDecideBookExperienceCta);
components.set('Image', Image);
components.set('JotForm', JotForm);
components.set('Link', Link);
components.set('LoyaltyLandingPageTable', LoyaltyLandingPageTable);
components.set('LoyaltyTable', LoyaltyTable);
components.set('LoyaltyTableContent', LoyaltyTableContent);
components.set('EventRegistration', EventRegistration);
components.set('FormWrapper', FormWrapper);
components.set('InformationForm', InformationForm);
components.set('LocationForm', LocationForm);
components.set('LocationStoreItem', LocationStoreItem);
components.set('MultiStepForm', MultiStepForm);
components.set('MemberEventCancel', MemberEventCancel);
components.set('MemberEventChange', MemberEventChange);
components.set('MemberEventDetail', MemberEventDetail);
components.set('EventBannerSwiper', EventBannerSwiper);
components.set('LocationSwiper', LocationSwiper);
components.set('MemberEventListing', MemberEventListing);
components.set('EventItem', EventItem);
components.set('MemberEventRegisteredOrChanged', MemberEventRegisteredOrChanged);
components.set('MemberEventsWidget', MemberEventsWidget);
components.set('MyAppointment', MyAppointment);
components.set('CancelMyAppointmentModal', CancelMyAppointmentModal);
components.set('Metadata', Metadata);
components.set('MonthDiscountedItems', MonthDiscountedItems);
components.set('MonthDiscountedSwiper', MonthDiscountedSwiper);
components.set('MyReviews', MyReviews);
components.set('MyRewardsWidget', MyRewardsWidget);
components.set('IsMemberLoyalty', IsMemberLoyalty);
components.set('IsNotMemberLoyalty', IsNotMemberLoyalty);
components.set('MyRewardWidgetLayout', MyRewardWidgetLayout);
components.set('NewsletterPopup', NewsletterPopup);
components.set('NewsletterForm', NewsletterForm);
components.set('OneColumn', OneColumn);
components.set('TwoColumn11', TwoColumn11);
components.set('FAQFrequentlyCTA', FAQFrequentlyCTA);
components.set('WarrantyRegistrationCTA', WarrantyRegistrationCTA);
components.set('TwoColumn41', TwoColumn41);
components.set('PartnerSpecial', PartnerSpecial);
components.set('PartnerSpecialDetailsSwiper', PartnerSpecialDetailsSwiper);
components.set('PartnerSpecialModal', PartnerSpecialModal);
components.set('PartnerSpecialsLanding', PartnerSpecialsLanding);
components.set('PartnerSpecialDetailAccordion', PartnerSpecialDetailAccordion);
components.set('PartnerSpecialsDetailLogo', PartnerSpecialsDetailLogo);
components.set('PaymentFail', PaymentFail);
components.set('PaymentOptions', PaymentOptions);
components.set('PaymentProcessing', PaymentProcessing);
components.set('OfferDetails', OfferDetails);
components.set('CartDetailsSection', CartDetailsSection);
components.set('OfferDetailsWidget', OfferDetailsWidget);
components.set('PersonalizedOfferWidget', PersonalizedOfferWidget);
components.set('ProductInfoSection', ProductInfoSection);
components.set('PersonalizedOffersWidget', PersonalizedOffersWidget);
components.set('LazyLoading', LazyLoading);
components.set('PersonalizedOffersWidgetBody', PersonalizedOffersWidgetBody);
components.set('PersonalizedOffersWidgetProvider', PersonalizedOffersWidgetProvider);
components.set('PopupBanner', PopupBanner);
components.set('AddToViewHistory', AddToViewHistory);
components.set('ContentSharingPlaceholder', ContentSharingPlaceholder);
components.set('FreeGift', FreeGift);
components.set('FreeGiftInfomationPopup', FreeGiftInfomationPopup);
components.set('MyWishlist', MyWishlist);
components.set('ProductWishlistItem', ProductWishlistItem);
components.set('ProductAlsoBought', ProductAlsoBought);
components.set('ProductContainer', ProductContainer);
components.set('ProductDetailSpec', ProductDetailSpec);
components.set('BackrestMassageUnit', BackrestMassageUnit);
components.set('Deminsion', Deminsion);
components.set('FootrestMassageUnit', FootrestMassageUnit);
components.set('ModelSpec', ModelSpec);
components.set('SeatMassageUnit', SeatMassageUnit);
components.set('WightModel', WightModel);
components.set('ProductItemView', ProductItemView);
components.set('ProductOverview', ProductOverview);
components.set('ProductRecommendation', ProductRecommendation);
components.set('ProductRecommendationItem', ProductRecommendationItem);
components.set('RelatedSpecialDeal', RelatedSpecialDeal);
components.set('ProductSpecialDealsItem', ProductSpecialDealsItem);
components.set('VariantDetail', VariantDetail);
components.set('ProductDescription', ProductDescription);
components.set('ProductDetailHeader', ProductDetailHeader);
components.set('CategoryProductItem', CategoryProductItem);
components.set('NotifyMePopup', NotifyMePopup);
components.set('ProductDetailHeaderBundle', ProductDetailHeaderBundle);
components.set('ProductDetailHeaderDynamicBundle', ProductDetailHeaderDynamicBundle);
components.set('ProductDetailHeaderMenu', ProductDetailHeaderMenu);
components.set('ProductHeaderPrice', ProductHeaderPrice);
components.set('ProductDetailOverview', ProductDetailOverview);
components.set('CustomPaginationSwiper', CustomPaginationSwiper);
components.set('ProductVariantImage', ProductVariantImage);
components.set('ProductVariantInfo', ProductVariantInfo);
components.set('termsConditionsModal', termsConditionsModal);
components.set('SwiperComponentZoom', SwiperComponentZoom);
components.set('ProductImages', ProductImages);
components.set('ProductImagesItem', ProductImagesItem);
components.set('ProductImagesMenu', ProductImagesMenu);
components.set('ProductPrice', ProductPrice);
components.set('ProductVariants', ProductVariants);
components.set('ProductAddedToCart', ProductAddedToCart);
components.set('ProductCardPrice', ProductCardPrice);
components.set('ProductCatalogue', ProductCatalogue);
components.set('ProductCatalogueItem', ProductCatalogueItem);
components.set('ProductCountdownTimer', ProductCountdownTimer);
components.set('ProductInstallmentCalculate', ProductInstallmentCalculate);
components.set('ArticleCarousel', ArticleCarousel);
components.set('CarouselDetailSlide', CarouselDetailSlide);
components.set('MobileApp', MobileApp);
components.set('CarouselImage', CarouselImage);
components.set('ListApp', ListApp);
components.set('ProductManual', ProductManual);
components.set('CarouselItem', CarouselItem);
components.set('CarouselWithItemTitle', CarouselWithItemTitle);
components.set('ProductHubInfo', ProductHubInfo);
components.set('ProductResourceListing', ProductResourceListing);
components.set('ResourceListing', ResourceListing);
components.set('MyProducts', MyProducts);
components.set('WarrantyProductItem', WarrantyProductItem);
components.set('MyProductsWidget', MyProductsWidget);
components.set('ProductDetail', ProductDetail);
components.set('ProductWarrantyDetail', ProductWarrantyDetail);
components.set('DownloadAppItemWidget', DownloadAppItemWidget);
components.set('DownloadOSIMAppDetail', DownloadOSIMAppDetail);
components.set('ProductReviewItemWidget', ProductReviewItemWidget);
components.set('RegistrationErrorPopup', RegistrationErrorPopup);
components.set('RemoveProductCTA', RemoveProductCTA);
components.set('WarrantyDetail', WarrantyDetail);
components.set('WarrantyRegisterLogin', WarrantyRegisterLogin);
components.set('WarrantyLoginForm', WarrantyLoginForm);
components.set('WarrantyRegisterForm', WarrantyRegisterForm);
components.set('WarrantyRegistration', WarrantyRegistration);
components.set('CategorySelect', CategorySelect);
components.set('DatePicker', DatePicker);
components.set('DatePurchase', DatePurchase);
components.set('OrderNumberInput', OrderNumberInput);
components.set('ProductWarrantySelect', ProductWarrantySelect);
components.set('SerialNumberInput', SerialNumberInput);
components.set('useWarrantyRegistrationFormik', useWarrantyRegistrationFormik);
components.set('WarrantyRegistrationProcess', WarrantyRegistrationProcess);
components.set('WarrantyRegistrationThankYou', WarrantyRegistrationThankYou);
components.set('DiscoverProductButton', DiscoverProductButton);
components.set('ProductPreviewSubmitted', ProductPreviewSubmitted);
components.set('ProductWarrantySubmitted', ProductWarrantySubmitted);
components.set('WarrantyRegistrationThankYouDescription', WarrantyRegistrationThankYouDescription);
components.set('PromotionDetailBundle', PromotionDetailBundle);
components.set('CreateBundle', CreateBundle);
components.set('BundleItems', BundleItems);
components.set('DynamicBundleElements', DynamicBundleElements);
components.set('PromotionDetailBundleItem', PromotionDetailBundleItem);
components.set('PromotionDetailBundleSwiper', PromotionDetailBundleSwiper);
components.set('PromotionHeader', PromotionHeader);
components.set('PromotionListing', PromotionListing);
components.set('PromotionListingItem', PromotionListingItem);
components.set('RawText', RawText);
components.set('RecentlyViewedProducts', RecentlyViewedProducts);
components.set('RecentlyViewedProductItem', RecentlyViewedProductItem);
components.set('RelatedFreeGift', RelatedFreeGift);
components.set('ResponsiveImage', ResponsiveImage);
components.set('ReviewPage', ReviewPage);
components.set('FullReviewListing', FullReviewListing);
components.set('LimitedReviewListing', LimitedReviewListing);
components.set('MyProductDetailReview', MyProductDetailReview);
components.set('MyProductReview', MyProductReview);
components.set('ProductReview', ProductReview);
components.set('ReviewInput', ReviewInput);
components.set('SubmitReviewProcess', SubmitReviewProcess);
components.set('ProductReviewContent', ProductReviewContent);
components.set('ProductReviewForPDP', ProductReviewForPDP);
components.set('NavigationBundleProduct', NavigationBundleProduct);
components.set('ProductReviewListing', ProductReviewListing);
components.set('ProductReviewSubmitted', ProductReviewSubmitted);
components.set('ReviewMedia', ReviewMedia);
components.set('ReviewMediaPopup', ReviewMediaPopup);
components.set('ReviewStarRating', ReviewStarRating);
components.set('ReviewsSummary', ReviewsSummary);
components.set('UploadMultipleFiles', UploadMultipleFiles);
components.set('VideoFile', VideoFile);
components.set('PolicySearchResult', PolicySearchResult);
components.set('PolicySearchResultItem', PolicySearchResultItem);
components.set('ProductSearchResult', ProductSearchResult);
components.set('ProductSearchResultFilterPopup', ProductSearchResultFilterPopup);
components.set('ProductSearchResultFilterColor', ProductSearchResultFilterColor);
components.set('ProductSearchResultFilterFeature', ProductSearchResultFilterFeature);
components.set('ProductSearchResultFilterPrice', ProductSearchResultFilterPrice);
components.set('ProductSearchResultItem', ProductSearchResultItem);
components.set('ResourceSearchItem', ResourceSearchItem);
components.set('AdditionalFullFilmentOption', AdditionalFullFilmentOption);
components.set('AutoCompleteUI', AutoCompleteUI);
components.set('Breadcrumb', Breadcrumb);
components.set('BuyingAccordion', BuyingAccordion);
components.set('BuyingFirstTypeHeader', BuyingFirstTypeHeader);
components.set('BuyingSecondTypeHeader', BuyingSecondTypeHeader);
components.set('BuyingTueTypeHeader', BuyingTueTypeHeader);
components.set('BuyingBundleAccordion', BuyingBundleAccordion);
components.set('BundleBOFirstTypeHeader', BundleBOFirstTypeHeader);
components.set('BundleBOSecondTypeHeader', BundleBOSecondTypeHeader);
components.set('CheckBox', CheckBox);
components.set('CountdownTimer', CountdownTimer);
components.set('CountdownTimerCampaign', CountdownTimerCampaign);
components.set('CountdownTimerItem', CountdownTimerItem);
components.set('CountdownTimerResend', CountdownTimerResend);
components.set('DynamicStripAds', DynamicStripAds);
components.set('ExperienceEditorError', ExperienceEditorError);
components.set('Footer', Footer);
components.set('IconList', IconList);
components.set('IconItem', IconItem);
components.set('LanguageSelector', LanguageSelector);
components.set('LanguageItem', LanguageItem);
components.set('FooterNavigation', FooterNavigation);
components.set('FooterNavigationItem', FooterNavigationItem);
components.set('FooterNavigationList', FooterNavigationList);
components.set('FooterNavigationTitle', FooterNavigationTitle);
components.set('GoogleAnalytic', GoogleAnalytic);
components.set('Header', Header);
components.set('AccountQuickAccess', AccountQuickAccess);
components.set('CatalogueNavigation', CatalogueNavigation);
components.set('MainNavigationSubItem', MainNavigationSubItem);
components.set('MainNavigationSubMenu', MainNavigationSubMenu);
components.set('VerticalTabLayout', VerticalTabLayout);
components.set('VerticalTabExtraLinkItem', VerticalTabExtraLinkItem);
components.set('VerticalTabItem', VerticalTabItem);
components.set('Hambuger', Hambuger);
components.set('HeaderMenu', HeaderMenu);
components.set('IconNavigation', IconNavigation);
components.set('IconNavigationItem', IconNavigationItem);
components.set('Logo', Logo);
components.set('MiniCart', MiniCart);
components.set('CartMiniItem', CartMiniItem);
components.set('CartMiniTotalAmount', CartMiniTotalAmount);
components.set('QuickNavigation', QuickNavigation);
components.set('QuickNavigationItem', QuickNavigationItem);
components.set('SearchBox', SearchBox);
components.set('SearchBoxInput', SearchBoxInput);
components.set('SearchBoxInputSuggestList', SearchBoxInputSuggestList);
components.set('HighlightedText', HighlightedText);
components.set('InfoStockComponent', InfoStockComponent);
components.set('InstagramAuthorization', InstagramAuthorization);
components.set('Loading', Loading);
components.set('LoadingMask', LoadingMask);
components.set('LoadingShimmer', LoadingShimmer);
components.set('Message', Message);
components.set('MissingDataApi', MissingDataApi);
components.set('ModalComponent', ModalComponent);
components.set('OmnichatTracking', OmnichatTracking);
components.set('OsimCheckBox', OsimCheckBox);
components.set('Pagination', Pagination);
components.set('PhoneNumberSelect', PhoneNumberSelect);
components.set('PlainHTML', PlainHTML);
components.set('Popup', Popup);
components.set('RichText', RichText);
components.set('FormSubmitErrorPopup', FormSubmitErrorPopup);
components.set('SocialNavigation', SocialNavigation);
components.set('SocialNavigationItem', SocialNavigationItem);
components.set('StoreLocator', StoreLocator);
components.set('StoreLocatorContent', StoreLocatorContent);
components.set('GoogleMap', GoogleMap);
components.set('StoreLocatorBar', StoreLocatorBar);
components.set('StoreLocatorFilterIcon', StoreLocatorFilterIcon);
components.set('StoreLocatorFilterModal', StoreLocatorFilterModal);
components.set('StoreLocatorFilterPopup', StoreLocatorFilterPopup);
components.set('StoreLocatorFilterPopupContent', StoreLocatorFilterPopupContent);
components.set('StoreLocatorSearch', StoreLocatorSearch);
components.set('StoreLocatorList', StoreLocatorList);
components.set('StoreLocatorListItem', StoreLocatorListItem);
components.set('StripAds', StripAds);
components.set('SwipeComponent', SwipeComponent);
components.set('SwipeWithThumbnailComponent', SwipeWithThumbnailComponent);
components.set('PreviewComponent', PreviewComponent);
components.set('ThumbnailComponent', ThumbnailComponent);
components.set('TabComponent', TabComponent);
components.set('ToggleWisList', ToggleWisList);
components.set('VideoPlayer', VideoPlayer);
components.set('PlayerControl', PlayerControl);
components.set('WechatAuthorization', WechatAuthorization);
components.set('YahooAuthorization', YahooAuthorization);
components.set('ShowInformationTiers', ShowInformationTiers);
components.set('Authentication', Authentication);
components.set('DateOfBirth', DateOfBirth);
components.set('FacebookSSO', FacebookSSO);
components.set('ForgotPassword', ForgotPassword);
components.set('GoogleSSO', GoogleSSO);
components.set('InstagramSSO', InstagramSSO);
components.set('LogoutComponent', LogoutComponent);
components.set('NewPassword', NewPassword);
components.set('PasswordHint', PasswordHint);
components.set('PasswordInput', PasswordInput);
components.set('RegisterLogin', RegisterLogin);
components.set('Login', Login);
components.set('Register', Register);
components.set('RegisterActiveMail', RegisterActiveMail);
components.set('TaskListAuthen', TaskListAuthen);
components.set('WechatSSO', WechatSSO);
components.set('YahooSSO', YahooSSO);
components.set('InfoBox', InfoBox);
components.set('TimelinePanel', TimelinePanel);
components.set('Carousel', Carousel);
components.set('ZoomSwiperComponent', ZoomSwiperComponent);
components.set('ZoomSwiperComponentItem', ZoomSwiperComponentItem);
components.set('ExpertPopupContent', ExpertPopupContent);
components.set('SimpleSquareTiles', SimpleSquareTiles);
components.set('SimpleSquareItem', SimpleSquareItem);
components.set('AddToCart', AddToCart);
components.set('BackToTop', BackToTop);
components.set('BalanceDetails', BalanceDetails);
components.set('BalanceDetailModals', BalanceDetailModals);
components.set('CarouselWidthIcon', CarouselWidthIcon);
components.set('CarouselWidthIconBottom', CarouselWidthIconBottom);
components.set('CarouselWidthIconTop', CarouselWidthIconTop);
components.set('CartDetails', CartDetails);
components.set('CartDetailModal', CartDetailModal);
components.set('CartEmty', CartEmty);
components.set('CartFulfilmentOption', CartFulfilmentOption);
components.set('CartHeadInfo', CartHeadInfo);
components.set('CartList', CartList);
components.set('CartItem', CartItem);
components.set('CPEditProductBtn', CPEditProductBtn);
components.set('CartAdditionalOptionItem', CartAdditionalOptionItem);
components.set('CartItemDelivery', CartItemDelivery);
components.set('CartItemFreeGift', CartItemFreeGift);
components.set('CartItemGiftingOption', CartItemGiftingOption);
components.set('CartItemInfor', CartItemInfor);
components.set('CartItemTotalPrice', CartItemTotalPrice);
components.set('CartRentalItem', CartRentalItem);
components.set('CartTradeInItem', CartTradeInItem);
components.set('CartWarrantyItem', CartWarrantyItem);
components.set('ConfirmRemoveCart', ConfirmRemoveCart);
components.set('ListItemSwiper', ListItemSwiper);
components.set('PromotionCart', PromotionCart);
components.set('CartMilstone', CartMilstone);
components.set('CartPromotionCodes', CartPromotionCodes);
components.set('AppliedCouponItem', AppliedCouponItem);
components.set('BaseCouponItem', BaseCouponItem);
components.set('PopUpCouponItem', PopUpCouponItem);
components.set('CartStripAds', CartStripAds);
components.set('CartSummary', CartSummary);
components.set('OfferAppliedModal', OfferAppliedModal);
components.set('SelectArealModalContentData', SelectArealModalContentData);
components.set('DeleteSaleOrderButton', DeleteSaleOrderButton);
components.set('SFExpressPopup', SFExpressPopup);
components.set('SFExpressPopupItem', SFExpressPopupItem);
components.set('ContactUs', ContactUs);
components.set('ContactUsIconList', ContactUsIconList);
components.set('ContactUsIconListItem', ContactUsIconListItem);
components.set('ContactUsCTA', ContactUsCTA);
components.set('Banner', Banner);
components.set('CountDownBanner', CountDownBanner);
components.set('FeaturedProducts', FeaturedProducts);
components.set('FeaturedProductItem', FeaturedProductItem);
components.set('FeaturedProductItemLi', FeaturedProductItemLi);
components.set('FeaturedTiles', FeaturedTiles);
components.set('FeaturedTilesItem', FeaturedTilesItem);
components.set('SimpleTiles', SimpleTiles);
components.set('SimpleTilesItem', SimpleTilesItem);
components.set('SliderBanners', SliderBanners);
components.set('SliderBannersItem', SliderBannersItem);
components.set('TwoColumnCTAButton', TwoColumnCTAButton);
components.set('MyAccount', MyAccount);
components.set('AccountSettings', AccountSettings);
components.set('ChangePassword', ChangePassword);
components.set('ChangePasswordSuccess', ChangePasswordSuccess);
components.set('ContactInformation', ContactInformation);
components.set('ContactInformationWidget', ContactInformationWidget);
components.set('ForgotEmail', ForgotEmail);
components.set('ChangeEmail', ChangeEmail);
components.set('VerifyThroughEmail', VerifyThroughEmail);
components.set('VerifyThroughOldEmail', VerifyThroughOldEmail);
components.set('NewsletterPreferenceWidget', NewsletterPreferenceWidget);
components.set('PasswordManagementWidget', PasswordManagementWidget);
components.set('SocialLoginsWidget', SocialLoginsWidget);
components.set('AddressesWidget', AddressesWidget);
components.set('AddressesDefault', AddressesDefault);
components.set('AppointmentBookedComponent', AppointmentBookedComponent);
components.set('RegisterAccountForm', RegisterAccountForm);
components.set('AppointmentDetails', AppointmentDetails);
components.set('AppointmentDetailContent', AppointmentDetailContent);
components.set('CancelAppointment', CancelAppointment);
components.set('CancelAppointmentModal', CancelAppointmentModal);
components.set('BookExperienceButtonComponent', BookExperienceButtonComponent);
components.set('MyAddress', MyAddress);
components.set('AddNewAddress', AddNewAddress);
components.set('AddressBook', AddressBook);
components.set('AddressForMultiLanguage', AddressForMultiLanguage);
components.set('AddressItem', AddressItem);
components.set('BillingAddress', BillingAddress);
components.set('ChangeBillingAddress', ChangeBillingAddress);
components.set('ConfirmRemoveAddress', ConfirmRemoveAddress);
components.set('EditAddressBookPopup', EditAddressBookPopup);
components.set('InfoAddress', InfoAddress);
components.set('ShippingAddress', ShippingAddress);
components.set('ChangeShippingAddress', ChangeShippingAddress);
components.set('MyAppointments', MyAppointments);
components.set('MyAppointmentsWidget', MyAppointmentsWidget);
components.set('MyOrders', MyOrders);
components.set('MyOrdersWidget', MyOrdersWidget);
components.set('MyWishlistWidget', MyWishlistWidget);
components.set('OrderDetails', OrderDetails);
components.set('OrderInfo', OrderInfo);
components.set('PaymentMethodComponent', PaymentMethodComponent);
components.set('SpecialRequestComponent', SpecialRequestComponent);
components.set('TotalOrder', TotalOrder);
components.set('model', model);
components.set('PersonalProfileWidget', PersonalProfileWidget);
components.set('SupportCentreWidget', SupportCentreWidget);
components.set('PaymentMethod', PaymentMethod);
components.set('ProductBanner', ProductBanner);
components.set('SimpleCards', SimpleCards);
components.set('SimpleCardItem', SimpleCardItem);
components.set('SubNavigation', SubNavigation);
components.set('SubNavigationItem', SubNavigationItem);
components.set('ProductSupportCTA', ProductSupportCTA);
components.set('ProductCategorySwiper', ProductCategorySwiper);
components.set('ProductSwiper', ProductSwiper);
components.set('PurchaseOnSpot', PurchaseOnSpot);
components.set('PurchaseOnSpotCompleted', PurchaseOnSpotCompleted);
components.set('ExploreOSIMProducts', ExploreOSIMProducts);
components.set('FeaturedCategories', FeaturedCategories);
components.set('InfoBoxWithImage', InfoBoxWithImage);
components.set('StoreExperiences', StoreExperiences);
components.set('StoreOverview', StoreOverview);
components.set('SlideUpBanner', SlideUpBanner);
components.set('SpecialRelatedProduct', SpecialRelatedProduct);
components.set('SpecialRelatedProductItem', SpecialRelatedProductItem);
components.set('SpinAndWin', SpinAndWin);
components.set('ApplyOfferPopup', ApplyOfferPopup);
components.set('ChanceToWinPopup', ChanceToWinPopup);
components.set('GiftUnavailable', GiftUnavailable);
components.set('HelpIcon', HelpIcon);
components.set('HowToPlayPopup', HowToPlayPopup);
components.set('MyPrizesPopup', MyPrizesPopup);
components.set('PrizesIcon', PrizesIcon);
components.set('Spin&WinBanner', SpinWinBanner);
components.set('Spin&WinHeading', SpinWinHeading);
components.set('SpinAndWinComponent', SpinAndWinComponent);
components.set('SpinAndWinContext', SpinAndWinContext);
components.set('SpinAndWinPopUp', SpinAndWinPopUp);
components.set('SpinCouponInfoPopup', SpinCouponInfoPopup);
components.set('SpinCouponItem', SpinCouponItem);
components.set('SpinForm', SpinForm);
components.set('SpinWheel', SpinWheel);
components.set('SpinWinPopup', SpinWinPopup);
components.set('SpinWinners', SpinWinners);
components.set('ViewMyPrizesButton', ViewMyPrizesButton);
components.set('StoreHeader', StoreHeader);
components.set('DownloadOsimApp', DownloadOsimApp);
components.set('ProductAccessories', ProductAccessories);
components.set('ProductManualDownload', ProductManualDownload);
components.set('SimpleCTA', SimpleCTA);
components.set('SupportCenterTitle', SupportCenterTitle);
components.set('TaxMessageDetail', TaxMessageDetail);
components.set('ThreeColumnBanner', ThreeColumnBanner);
components.set('TierBenefit', TierBenefit);
components.set('TierBenefitAnchor', TierBenefitAnchor);
components.set('Title', Title);
components.set('TradeInSpecialRewards', TradeInSpecialRewards);
components.set('TradeInSpecialRewardsItem', TradeInSpecialRewardsItem);
components.set('TradeInSpecialRewardsSwiper', TradeInSpecialRewardsSwiper);
components.set('TwoColumnImage', TwoColumnImage);
components.set('TwoColumnImageWithAccodion', TwoColumnImageWithAccodion);
components.set('TwoColumnImageWithAccodionItem', TwoColumnImageWithAccodionItem);
components.set('TwoColumnWithTextImage', TwoColumnWithTextImage);
components.set('Typography', Typography);
components.set('UniversalSearchBox', UniversalSearchBox);
components.set('Unsubscribe', Unsubscribe);
components.set('Video', Video);
components.set('VisitedCategoryPage', VisitedCategoryPage);
components.set('VisitedProductPage', VisitedProductPage);
components.set('BannerWithRichTextOverlay', BannerWithRichTextOverlay);
components.set('FeaturedArticle', FeaturedArticle);
components.set('FeaturedArticleItem', FeaturedArticleItem);
components.set('LatestArticle', LatestArticle);
components.set('OtherWellnessContents', OtherWellnessContents);
components.set('SearchBoxArticle', SearchBoxArticle);
components.set('SingleFeaturedProduct', SingleFeaturedProduct);
components.set('WellBeingProducts', WellBeingProducts);
components.set('WellBeingProductItem', WellBeingProductItem);
components.set('WellnessArticleItem', WellnessArticleItem);
components.set('WellnessContents', WellnessContents);
components.set('WellnessDetailHeader', WellnessDetailHeader);
components.set('WellnessDetailHeaderTagItem', WellnessDetailHeaderTagItem);
components.set('WellnessFilterTag', WellnessFilterTag);
components.set('WellnessListing', WellnessListing);
components.set('WellnessListingItem', WellnessListingItem);
components.set('WellnessListingSearch', WellnessListingSearch);
components.set('WhyChooseOsim', WhyChooseOsim);
components.set('YourProductHubDetail', YourProductHubDetail);
components.set('ProductHubItem', ProductHubItem);
components.set('CategoryLanding', CategoryLanding);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
